<template>
    <a
        v-if="canManagePriceList"
        href="#"
        id="section1"
        ref="section1"
    ></a>
    <v-card class="mt-3">
        <v-toolbar>
            <v-toolbar-title> Listă prețuri  </v-toolbar-title>
            <v-spacer />
            <v-btn
                v-if="canManagePriceList"
                icon
                color="info"
                class="mr-4"
                :disabled="priceLists.length < 2"
                @click="openCompareDialog"
            >
                <v-icon>mdi-compare-horizontal</v-icon>
                <v-tooltip activator="parent" location="bottom">
                    Compară liste
                </v-tooltip>
            </v-btn>
        </v-toolbar>
        <v-container v-if="canManagePriceList">
            <v-row>
                <v-col>
                    <v-select
                        :items="priceListTypes"
                        v-model="selectedPriceListType"
                        variant="outlined"
                        item-title="title"
                        item-value="value"
                        label="Selectează tipul listei de preț"
                        density="compact"
                        hide-details="auto"
                        @change="getPriceLists" />
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row v-if="selectedPriceList" class="align-center">
                <v-col cols="12" sm="6" md="3">
                    <v-text-field
                        v-model="listPricingSettingsForm.exchangeRateEur"
                        label="Curs EUR"
                        :variant="this.$store.state.vuetifyFieldType"
                        density="compact"
                        hide-details="auto" />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-text-field
                        v-model="listPricingSettingsForm.exchangeRatePln"
                        label="Curs PLN"
                        :variant="this.$store.state.vuetifyFieldType"
                        density="compact"
                        hide-details="auto" />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-text-field
                        v-model="listPricingSettingsForm.exchangeRateUsd"
                        label="Curs USD"
                        :variant="this.$store.state.vuetifyFieldType"
                        density="compact"
                        hide-details="auto" />
                </v-col>
                <v-col cols="12" sm="6" md="3" class="d-flex align-center">
                    <v-btn
                        class="w-100"
                        color="primary"
                        style="color: white !important"
                        :loading="savingListPricingSettings"
                        @click="saveListPricingSettings">
                        Salvează cursuri
                    </v-btn>
                </v-col>
            </v-row>
            <v-divider></v-divider>
        </v-container>
        <a
            v-if="canUsePriceListEditor"
            href="#"
            id="section-drafts"
            ref="section-drafts"
        ></a>
        <v-card-item>
            <PriceListDraftPanel
                v-if="canUsePriceListEditor"
                :drafts="productDrafts"
                :items="items"
                :publishing="publishingDrafts"
                :can-publish="canManagePriceList"
                :can-clear-all="canManagePriceList"
                :restrict-actions-to-de-verificat="isPriceListVerifier"
                @edit="editProductDraft"
                @remove="removeProductDraft"
                @clear="clearProductDrafts"
                @publish="openPublishDraftsDialog"
                @set-default-furnizor="onDraftSetDefaultFurnizor" />
            <a href="#" id="section2" ref="section2"></a>
            <v-locale-provider :locale="this.$store.state.i18nLocale">
                <v-data-table-server
                    :variant="this.$store.state.vuetifyFieldType"
                    clearable
                    :hide-default-footer="!productsPanelExpanded"
                    :headers="productsPanelExpanded ? tableHeaders : []"
                    :items="productsPanelExpanded ? sortedDisplayItems : []"
                    :page="productsPage"
                    :items-per-page="productsItemsPerPage"
                    :items-per-page-options="productsItemsPerPageOptions"
                    :items-length="productsTotalCount"
                    v-model:sort-by="productsSortBy"
                    :class="['elevation-1 products-table', { 'products-table-collapsed': !productsPanelExpanded }]"
                    :loading="productsPanelExpanded && loading"
                    :height="productsTableHeight"
                    :row-props="productRowProps"
                    :fixed-header="productsTableFixedHeader"
                    @update:page="onProductsPageChange"
                    @update:items-per-page="onProductsItemsPerPageChange">
                    <template v-slot:top>
                        <div ref="toolbarRef">
                            <v-toolbar class="products-toolbar">
                                <div class="products-toolbar-inner">
                                    <v-toolbar-title
                                        class="products-toolbar-title subtitle-2">
                                        Produse
                                    </v-toolbar-title>
                                    <div
                                        v-if="$vuetify.display.mdAndUp && productsPanelExpanded"
                                        class="products-toolbar-controls">
                                        <v-text-field
                                            class="products-toolbar-field"
                                            variant="outlined"
                                            clearable
                                            v-model="search"
                                            density="compact"
                                            prepend-inner-icon="mdi-magnify"
                                            label="Caută"
                                            single-line
                                            hide-details="auto"></v-text-field>
                                        <div class="products-toolbar-field">
                                            <v-menu
                                                v-model="structureFilterMenuOpen"
                                                :close-on-content-click="false"
                                                location="bottom start"
                                            >
                                                <template #activator="{ props: menuProps }">
                                                    <v-text-field
                                                        v-bind="menuProps"
                                                        :model-value="structureFilterDisplay"
                                                        label="Filtrează"
                                                        variant="outlined"
                                                        density="compact"
                                                        hide-details="auto"
                                                        readonly
                                                        clearable
                                                        prepend-inner-icon="mdi-filter-variant"
                                                        append-inner-icon="mdi-chevron-down"
                                                        @click:clear.stop="clearStructureFilter"
                                                    />
                                                </template>
                                                <v-card min-width="320" elevation="8">
                                                    <v-card-text class="d-flex flex-column ga-3 pt-4">
                                                        <v-select
                                                            v-model="selectedChapterFilter"
                                                            :items="chapterFilterOptions"
                                                            item-title="title"
                                                            item-value="value"
                                                            label="Categorie"
                                                            variant="outlined"
                                                            density="compact"
                                                            hide-details
                                                            clearable
                                                            @update:model-value="onChapterFilterChange"
                                                        />
                                                        <v-select
                                                            v-model="selectedSubchapterFilter"
                                                            :items="subchapterFilterOptions"
                                                            item-title="title"
                                                            item-value="value"
                                                            label="Subcategorie"
                                                            variant="outlined"
                                                            density="compact"
                                                            hide-details
                                                            clearable
                                                            :disabled="!selectedChapterFilter"
                                                            @update:model-value="onSubchapterFilterChange"
                                                        />
                                                    </v-card-text>
                                                </v-card>
                                            </v-menu>
                                        </div>
                                        <v-select
                                            v-if="canUsePriceListEditor"
                                            class="products-toolbar-field"
                                            variant="outlined"
                                            density="compact"
                                            v-model="selectedPriceList"
                                            :items="priceLists"
                                            :item-title="priceListItemTitle"
                                            item-value="id"
                                            label="Listă preț"
                                            closable-chips
                                            hide-details="auto"
                                            prepend-inner-icon="mdi-format-list-bulleted"
                                            @update:modelValue="
                                                getPriceListProducts
                                            "></v-select>
                                        <div
                                            v-if="canUsePriceListEditor"
                                            class="products-toolbar-actions">
                                            <v-btn
                                                icon
                                                color="primary"
                                                @click="openBuilderDialog">
                                                <v-icon
                                                    >mdi-plus-circle-outline</v-icon
                                                >
                                                <v-tooltip
                                                    activator="parent"
                                                    location="bottom">
                                                    Creează produs nou
                                                </v-tooltip>
                                            </v-btn>
                                            <v-btn
                                                v-if="canManagePriceList"
                                                icon
                                                color="secondary"
                                                :disabled="!items.length"
                                                @click="openBulkPropertyDialog()">
                                                <v-icon>mdi-table-edit</v-icon>
                                                <v-tooltip
                                                    activator="parent"
                                                    location="bottom">
                                                    Actualizare în masă
                                                </v-tooltip>
                                            </v-btn>
                                        </div>
                                    </div>
                                    <div
                                        v-if="!productsPanelExpanded"
                                        class="products-toolbar-spacer" />
                                    <v-btn
                                        icon
                                        variant="text"
                                        class="products-toolbar-toggle"
                                        :aria-label="productsPanelExpanded ? 'Ascunde produse' : 'Arata produse'"
                                        @click.stop="toggleProductsPanel"
                                    >
                                        <v-icon>{{ productsPanelExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                    </v-btn>
                                </div>
                            </v-toolbar>
                            <div
                                v-if="$vuetify.display.smAndDown && productsPanelExpanded"
                                class="d-flex flex-column ga-4 px-3 py-3">
                                <v-text-field
                                    variant="outlined"
                                    clearable
                                    v-model="search"
                                    density="compact"
                                    prepend-inner-icon="mdi-magnify"
                                    label="Caută"
                                    single-line
                                    hide-details="auto"></v-text-field>
                                <v-row>
                                    <v-col cols="12" sm="6" class="py-2">
                                        <v-menu
                                            v-model="structureFilterMenuOpen"
                                            :close-on-content-click="false"
                                            location="bottom start"
                                        >
                                            <template #activator="{ props: menuProps }">
                                                <v-text-field
                                                    v-bind="menuProps"
                                                    :model-value="structureFilterDisplay"
                                                    label="Filtrează"
                                                    variant="outlined"
                                                    density="compact"
                                                    hide-details="auto"
                                                    readonly
                                                    clearable
                                                    prepend-inner-icon="mdi-filter-variant"
                                                    append-inner-icon="mdi-chevron-down"
                                                    @click:clear.stop="clearStructureFilter"
                                                />
                                            </template>
                                            <v-card min-width="320" elevation="8">
                                                <v-card-text class="d-flex flex-column ga-3 pt-4">
                                                    <v-select
                                                        v-model="selectedChapterFilter"
                                                        :items="chapterFilterOptions"
                                                        item-title="title"
                                                        item-value="value"
                                                        label="Categorie"
                                                        variant="outlined"
                                                        density="compact"
                                                        hide-details
                                                        clearable
                                                        @update:model-value="onChapterFilterChange"
                                                    />
                                                    <v-select
                                                        v-model="selectedSubchapterFilter"
                                                        :items="subchapterFilterOptions"
                                                        item-title="title"
                                                        item-value="value"
                                                        label="Subcategorie"
                                                        variant="outlined"
                                                        density="compact"
                                                        hide-details
                                                        clearable
                                                        :disabled="!selectedChapterFilter"
                                                        @update:model-value="onSubchapterFilterChange"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-menu>
                                    </v-col>
                                    <v-col v-if="canUsePriceListEditor" cols="12" sm="6" class="py-2">
                                        <v-select
                                            variant="outlined"
                                            density="compact"
                                            v-model="selectedPriceList"
                                            :items="priceLists"
                                            :item-title="priceListItemTitle"
                                            item-value="id"
                                            label="Listă preț"
                                            closable-chips
                                            hide-details="auto"
                                            prepend-inner-icon="mdi-format-list-bulleted"
                                            @update:modelValue="
                                                getPriceListProducts
                                            "></v-select>
                                    </v-col>
                                </v-row>
                                <div
                                    v-if="canUsePriceListEditor"
                                    class="d-flex ga-3 justify-end">
                                    <v-btn
                                        icon
                                        color="primary"
                                        @click="openBuilderDialog">
                                        <v-icon>mdi-plus-circle-outline</v-icon>
                                        <v-tooltip
                                            activator="parent"
                                            location="bottom">
                                            Creează produs nou
                                        </v-tooltip>
                                    </v-btn>
                                    <v-btn
                                        v-if="canManagePriceList"
                                        icon
                                        color="secondary"
                                        :disabled="!items.length"
                                        @click="openBulkPropertyDialog()">
                                        <v-icon>mdi-table-edit</v-icon>
                                        <v-tooltip
                                            activator="parent"
                                            location="bottom">
                                            Actualizare în masă
                                        </v-tooltip>
                                    </v-btn>
                                </div>
                            </div>
                            <v-dialog
                                v-model="dialogDeleteChoice"
                                width="560"
                                :fullscreen="$vuetify.display.smAndDown">
                                <v-card>
                                    <v-card-title class="text-h6">
                                        Ștergere sau anulare produs
                                    </v-card-title>
                                    <v-card-text>
                                        <p
                                            v-if="editedItem?.product_code"
                                            class="mb-0">
                                            <strong>{{ editedItem.product_code }}</strong>
                                            —
                                            {{ editedItem.product_name }}
                                        </p>
                                    </v-card-text>
                                    <v-card-actions class="flex-wrap ga-1">
                                        <v-spacer />
                                        <v-btn
                                            color="primary"
                                            variant="text"
                                            @click="closeDelete">
                                            Renunță
                                        </v-btn>
                                        <v-btn
                                            color="error"
                                            variant="text"
                                            @click="requestDeleteFromLists">
                                            Șterge din listă
                                        </v-btn>
                                        <v-btn
                                            color="warning"
                                            variant="tonal"
                                            :loading="markingAsAnulat"
                                            @click="requestMarkAsAnulat">
                                            Mută în Anulat
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog
                                v-model="dialogDelete"
                                width="600"
                                :fullscreen="$vuetify.display.smAndDown">
                                <v-card>
                                    <v-card-title class="text-h5 d-flex align-center ga-2">
                                        <v-icon color="error" size="28">
                                            mdi-alert-octagon
                                        </v-icon>
                                        Atenție — această acțiune este ireversibilă
                                    </v-card-title>
                                    <v-card-text>
                                        <p class="mb-2 text-medium-emphasis">
                                            Din care listă de prețuri vrei să
                                            ștergi produsul?
                                        </p>
                                        <v-col
                                            v-for="(
                                                priceListGroup, type
                                            ) in groupedPriceLists"
                                            :key="type"
                                            cols="12"
                                            class="px-0">
                                            <v-select
                                                :variant="
                                                    this.$store.state
                                                        .vuetifyFieldType
                                                "
                                                clearable
                                                v-model="
                                                    editedItem.price_list_ids[
                                                        type
                                                    ]
                                                "
                                                :items="priceListGroup"
                                                :item-title="priceListItemTitle"
                                                item-value="id"
                                                :label="`Lista prețuri ${
                                                    this.$store.state
                                                        .PRICE_LIST_TYPES[
                                                        type.toUpperCase()
                                                    ].translation
                                                }`"
                                                chips
                                                multiple
                                                closable-chips></v-select>
                                        </v-col>
                                        <v-text-field
                                            v-model="deleteConfirmText"
                                            label='Tastează „sterge” pentru confirmare'
                                            :variant="
                                                this.$store.state.vuetifyFieldType
                                            "
                                            density="compact"
                                            hide-details="auto"
                                            autocomplete="off"
                                            class="mt-2"
                                            @keyup.enter="
                                                canConfirmDelete &&
                                                    deleteItemConfirm()
                                            " />
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="danger"
                                            variant="text"
                                            @click="closeDelete"
                                            >Anulează
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            variant="text"
                                            :disabled="!canConfirmDelete"
                                            @click="deleteItemConfirm"
                                            >Șterge
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </div>
                    </template>
                    <template v-slot:[`header.furnizor`]="{ column }">
                        <span class="header-title-wrap mr-1">
                            {{ column.title }}
                        </span>
                        <v-icon
                            style="cursor: pointer;"
                            size="small"
                            :color="selectedFurnizorFilter ? 'primary' : undefined"
                            class="fas fa-chevron-down">
                            <v-menu
                                activator="parent"
                                :close-on-content-click="false"
                                class="table-dropdown-menu"
                                @update:model-value="(v) => { if (!v) furnizorSearch = ''; }">
                                <v-card
                                    variant="outlined"
                                    style="max-height: 11cm; min-width: 4.5cm; display: flex; flex-direction: column;">
                                    <v-card-text class="pa-2 pb-1">
                                        <v-text-field
                                            v-model="furnizorSearch"
                                            label="Caută..."
                                            variant="outlined"
                                            density="compact"
                                            hide-details
                                            clearable
                                            autofocus
                                            @click.stop
                                        />
                                    </v-card-text>
                                    <v-list
                                        style="list-style: none; overflow: auto;"
                                        density="compact">
                                        <v-list-item
                                            :active="!selectedFurnizorFilter"
                                            active-class="active-item"
                                            @click="clearFurnizorFilter">
                                            Toate
                                        </v-list-item>
                                        <v-list-item
                                            :active="selectedFurnizorFilter === multipleFurnizoriFilterValue"
                                            active-class="active-item"
                                            @click="toggleFurnizorFilter(multipleFurnizoriFilterValue)">
                                            <div class="d-flex justify-space-between align-center flex-row w-100">
                                                <v-list-item-title>
                                                    Mai mulți furnizori 
                                                </v-list-item-title>
                                                <v-icon
                                                    v-if="selectedFurnizorFilter === multipleFurnizoriFilterValue"
                                                    color="danger">
                                                    mdi-delete
                                                </v-icon>
                                            </div>
                                        </v-list-item>
                                        <v-divider />
                                        <v-list-item
                                            v-for="option in furnizorFilterOptionsFiltered"
                                            :key="option.value"
                                            :value="option.value"
                                            :active="selectedFurnizorFilter === option.value"
                                            active-class="active-item"
                                            @click="toggleFurnizorFilter(option.value)">
                                            <div class="d-flex justify-space-between align-center flex-row w-100">
                                                <v-list-item-title>
                                                    {{ option.title }}
                                                </v-list-item-title>
                                                <v-icon
                                                    v-if="selectedFurnizorFilter === option.value"
                                                    color="danger">
                                                    mdi-delete
                                                </v-icon>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-menu>
                        </v-icon>
                    </template>
                    <template v-slot:[`header.categories`]="{ column }">
                        <span class="header-title-wrap mr-1">
                            {{ column.title }}
                        </span>
                        <v-icon
                            style="cursor: pointer;"
                            size="small"
                            :color="selectedSystemFilter ? 'primary' : undefined"
                            class="fas fa-chevron-down">
                            <v-menu
                                activator="parent"
                                :close-on-content-click="false"
                                class="table-dropdown-menu"
                                @update:model-value="(v) => { if (!v) sistemSearch = ''; }">
                                <v-card
                                    variant="outlined"
                                    style="max-height: 11cm; min-width: 4.5cm; display: flex; flex-direction: column;">
                                    <v-card-text class="pa-2 pb-1">
                                        <v-text-field
                                            v-model="sistemSearch"
                                            label="Caută..."
                                            variant="outlined"
                                            density="compact"
                                            hide-details
                                            clearable
                                            autofocus
                                            @click.stop
                                        />
                                    </v-card-text>
                                    <v-list
                                        style="list-style: none; overflow: auto;"
                                        density="compact">
                                        <v-list-item
                                            :active="!selectedSystemFilter"
                                            active-class="active-item"
                                            @click="clearSystemFilter">
                                            Toate
                                        </v-list-item>
                                        <v-divider />
                                        <v-list-item
                                            v-for="option in categoryFilterOptionsFiltered"
                                            :key="option.value"
                                            :value="option.value"
                                            :active="selectedSystemFilter === option.value"
                                            active-class="active-item"
                                            @click="toggleSystemFilter(option.value)">
                                            <div class="d-flex justify-space-between align-center flex-row w-100">
                                                <v-list-item-title>
                                                    {{ option.title }}
                                                </v-list-item-title>
                                                <v-icon
                                                    v-if="selectedSystemFilter === option.value"
                                                    color="danger">
                                                    mdi-delete
                                                </v-icon>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-menu>
                        </v-icon>
                    </template>
                    <template v-slot:[`item.serial_number`]="{ item }">
                        <div class="d-flex justify-center">
                            <v-checkbox
                                :model-value="getSerialNumberChecked(item)"
                                density="compact"
                                hide-details
                                color="primary"
                                class="ma-0 pa-0"
                                :disabled="!canManagePriceList || isSerialNumberSaving(item) || Boolean(item.is_multi_furnizor_child)"
                                @click.stop
                                @update:model-value="
                                    value => onSerialNumberToggle(item, value)
                                "
                            />
                        </div>
                    </template>
                    <template v-slot:[`item.product_code`]="{ item }">
                        <div
                            class="d-flex align-center justify-center ga-1 product-code-cell"
                            :class="{ 'product-code-cell--child': item.is_multi_furnizor_child }"
                        >
                            <v-btn
                                v-if="canViewFullPriceList && item.has_multiple_furnizori && !item.is_multi_furnizor_child"
                                icon
                                variant="text"
                                size="x-small"
                                density="compact"
                                class="multi-furnizor-toggle"
                                :color="isMultiFurnizorExpanded(item) ? 'primary' : undefined"
                                :aria-label="isMultiFurnizorExpanded(item)
                                    ? 'Colapsează furnizorii suplimentari'
                                    : 'Arată ceilalți furnizori'"
                                @click.stop="toggleMultiFurnizorExpand(item)"
                            >
                                <v-icon size="small">
                                    {{ isMultiFurnizorExpanded(item)
                                        ? 'mdi-chevron-down'
                                        : 'mdi-chevron-right' }}
                                </v-icon>
                                <v-tooltip activator="parent" location="top">
                                    {{ isMultiFurnizorExpanded(item)
                                        ? 'Colapsează — doar furnizorul implicit'
                                        : 'Anulează colapsarea — arată toți furnizorii' }}
                                </v-tooltip>
                            </v-btn>
                            <span
                                v-else-if="item.is_multi_furnizor_child"
                                class="multi-furnizor-child-spacer"
                                aria-hidden="true"
                            />
                            <span
                                v-if="canViewFullPriceList && item.manufacturer_product_code"
                                :class="{ 'text-medium-emphasis': item.is_multi_furnizor_child }"
                            >
                                {{ item.product_code }}
                                <v-tooltip activator="parent" location="top">
                                    {{ item.manufacturer_product_code }}
                                </v-tooltip>
                            </span>
                            <span
                                v-else
                                :class="{ 'text-medium-emphasis': item.is_multi_furnizor_child }"
                            >{{ item.product_code }}</span>
                        </div>
                    </template>
                    <template v-slot:[`item.measurement_unit`]="{ item }">
                        <div class="cell-center">{{ item.measurement_unit || '—' }}</div>
                    </template>
                    <template v-slot:[`item.product_name`]="{ item }">
                        <span
                            v-if="canViewFullPriceList && item.manufacturer_product_name"
                            :style="canEditPriceListItem(item) ? { cursor: 'pointer' } : undefined"
                            @click="canEditPriceListItem(item) && editItem(item)">
                            {{ item.product_name }}
                            <v-tooltip activator="parent" location="top">
                                {{ item.manufacturer_product_name }}
                            </v-tooltip>
                        </span>
                        <span
                            v-else
                            :style="canEditPriceListItem(item) ? { cursor: 'pointer' } : undefined"
                            @click="canEditPriceListItem(item) && editItem(item)">
                            {{ item.product_name }}
                        </span>
                    </template>
                    <template v-slot:[`header.status`]="{ column }">
                        <span class="header-title-wrap mr-1">
                            {{ column.title }}
                        </span>
                        <v-icon
                            style="cursor: pointer;"
                            size="small"
                            :color="selectedStatusFilter ? 'primary' : undefined"
                            class="fas fa-chevron-down">
                            <v-menu
                                activator="parent"
                                :close-on-content-click="true"
                                class="table-dropdown-menu">
                                <v-card
                                    variant="outlined"
                                    style="min-width: 4.5cm; display: flex; flex-direction: column;">
                                    <v-list style="list-style: none;" density="compact">
                                        <v-list-item
                                            :active="!selectedStatusFilter"
                                            active-class="active-item"
                                            @click="selectedStatusFilter = null">
                                            Toate
                                        </v-list-item>
                                        <v-divider />
                                        <v-list-item
                                            v-for="option in statusFilterOptions"
                                            :key="option.value"
                                            :active="selectedStatusFilter === option.value"
                                            active-class="active-item"
                                            @click="toggleStatusFilter(option.value)">
                                            {{ option.title }}
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-menu>
                        </v-icon>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <span :style="productStatusTextStyle(item.status)">
                            {{ formatProductStatusLabel(item.status) }}
                        </span>
                    </template>
                    <template v-slot:[`item.notes`]="{ item }">
                        <v-tooltip
                            v-if="getProductNotes(item)"
                            location="top"
                        >
                            <template #activator="{ props }">
                                <v-icon
                                    v-bind="props"
                                    size="small"
                                    color="primary"
                                >
                                    mdi-note-text-outline
                                </v-icon>
                            </template>
                            <div
                                style="max-width: 320px; white-space: pre-wrap; word-break: break-word;"
                            >
                                {{ getProductNotes(item) }}
                            </div>
                        </v-tooltip>
                        <span v-else>—</span>
                    </template>
                    <template v-slot:[`item.price_ex_vat`]="{ item }">
                        {{ formatRonPrice(item.price_ex_vat, 2, true) }}
                    </template>
                    <template v-slot:[`item.price`]="{ item }">
                        {{ formatRonPrice(item.price, 2, true) }}
                    </template>
                    <template v-slot:[`item.supplier_list_price`]="{ item }">
                        {{ formatRonPrice(item.supplier_list_price, 4, item.currency) }}
                    </template>
                    <template v-slot:[`item.has_discounts`]="{ item }">
                        <v-tooltip
                            v-if="item.has_discounts && item.discount_tooltip"
                            location="top"
                            open-on-hover
                            :open-delay="150"
                        >
                            <template #activator="{ props }">
                                <span
                                    v-bind="props"
                                    class="discount-cell discount-cell--yes"
                                >
                                    Da
                                </span>
                            </template>
                            <div class="discount-tooltip">
                                {{ item.discount_tooltip }}
                            </div>
                        </v-tooltip>
                        <span v-else-if="item.has_discounts">Da</span>
                        <span v-else class="text-medium-emphasis">—</span>
                    </template>
                    <template v-slot:[`item.transport_cost_rate`]="{ item }">
                        {{ formatPercentOrDash(item.transport_cost_rate) }}
                    </template>
                    <template v-slot:[`item.entry_price_ron_inc_vat`]="{ item }">
                        {{ formatRonPrice(item.entry_price_ron_inc_vat, 2, true) }}
                    </template>
                    <template v-slot:[`header.markup_reference`]="{ column }">
                        <span class="header-title-wrap mr-1">
                            {{ column.title }}
                        </span>
                        <v-icon
                            style="cursor: pointer;"
                            size="small"
                            :color="hasMarkupReferenceFilter ? 'primary' : undefined"
                            class="fas fa-chevron-down">
                            <v-menu
                                activator="parent"
                                :close-on-content-click="false"
                                class="table-dropdown-menu">
                                <v-card variant="outlined" style="min-width: 220px;">
                                    <v-card-text class="d-flex flex-column ga-2 pa-3">
                                        <v-select
                                            v-model="markupReferenceFilterOp"
                                            :items="markupFilterOpOptions"
                                            item-title="title"
                                            item-value="value"
                                            label="Condiție"
                                            variant="outlined"
                                            density="compact"
                                            hide-details
                                            @update:model-value="onMarkupReferenceFilterOpChange"
                                        />
                                        <v-text-field
                                            v-if="markupReferenceFilterOp"
                                            v-model="markupReferenceFilterPercent"
                                            label="Prag (%)"
                                            variant="outlined"
                                            density="compact"
                                            hide-details
                                            clearable
                                            type="number"
                                            inputmode="decimal"
                                            suffix="%"
                                        />
                                    </v-card-text>
                                </v-card>
                            </v-menu>
                        </v-icon>
                    </template>
                    <template v-slot:[`header.markup_actual`]="{ column }">
                        <span class="header-title-wrap mr-1">
                            {{ column.title }}
                        </span>
                        <v-icon
                            style="cursor: pointer;"
                            size="small"
                            :color="hasMarkupActualFilter ? 'primary' : undefined"
                            class="fas fa-chevron-down">
                            <v-menu
                                activator="parent"
                                :close-on-content-click="false"
                                class="table-dropdown-menu">
                                <v-card variant="outlined" style="min-width: 280px;">
                                    <v-card-text class="d-flex flex-column ga-2 pa-3">
                                        <v-select
                                            v-model="markupActualFilterOp"
                                            :items="markupActualFilterOpOptions"
                                            item-title="title"
                                            item-value="value"
                                            label="Condiție"
                                            variant="outlined"
                                            density="compact"
                                            hide-details
                                            @update:model-value="onMarkupActualFilterOpChange"
                                        />
                                        <v-text-field
                                            v-if="markupActualFilterOp === 'gt' || markupActualFilterOp === 'lt'"
                                            v-model="markupActualFilterPercent"
                                            label="Prag (%)"
                                            variant="outlined"
                                            density="compact"
                                            hide-details
                                            clearable
                                            type="number"
                                            inputmode="decimal"
                                            suffix="%"
                                        />
                                    </v-card-text>
                                </v-card>
                            </v-menu>
                        </v-icon>
                    </template>
                    <template v-slot:[`item.markup_reference`]="{ item }">
                        {{ formatPercentOrDash(item.markup_reference) }}
                    </template>
                    <template v-slot:[`item.markup_actual`]="{ item }">
                        <span :class="markupActualDiffClass(item)">
                            {{ formatPercentOrDash(item.markup_actual) }}
                        </span>
                    </template>
                    <template v-slot:[`item.categories`]="{ item }">
                        <div
                            v-if="getProductMainCategories(item).length"
                            class="d-flex flex-wrap ga-1 py-1 justify-center">
                            <v-chip
                                v-for="categoryName in getProductMainCategories(
                                    item,
                                )"
                                :key="categoryName"
                                size="x-small"
                                variant="flat"
                                :color="getCategoryColor(categoryName)"
                                style="color: white">
                                {{ getCategoryShortLabel(categoryName) }}
                            </v-chip>
                        </div>
                        <span v-else class="text-medium-emphasis">—</span>
                    </template>
                    <template v-slot:[`item.furnizor`]="{ item }">
                        <div
                            v-if="item.furnizor || getPrimaryFurnizorLabel(item)"
                            class="furnizor-cell"
                        >
                            <span class="furnizor-cell__label">
                                {{ item.furnizor || getPrimaryFurnizorLabel(item) }}
                            </span>
                            <v-chip
                                v-if="item.is_default && item.has_multiple_furnizori && isMultiFurnizorExpanded(item)"
                                size="x-small"
                                variant="tonal"
                                color="primary"
                                class="furnizor-cell__chip"
                            >
                                implicit
                            </v-chip>
                            <span
                                v-else-if="!item.is_multi_furnizor_child && getItemFurnizorLabels(item).length > 1"
                                class="furnizor-cell__star text-medium-emphasis"
                            >*</span>
                            <v-tooltip
                                v-if="!item.is_multi_furnizor_child && getItemFurnizorLabels(item).length > 1 && !isMultiFurnizorExpanded(item)"
                                activator="parent"
                                location="top"
                            >
                                <div class="text-caption font-weight-medium mb-1">
                                    Furnizori:
                                </div>
                                <div
                                    v-for="(row, index) in getItemFurnizorLabels(item)"
                                    :key="`furnizor-${item.product_code || item.id}-${index}`"
                                >
                                    {{ row.label }}
                                    <template v-if="row.isDefault"> (implicit)</template>
                                </div>
                            </v-tooltip>
                        </div>
                        <span v-else class="text-medium-emphasis">—</span>
                    </template>
                    <template v-slot:[`header.visible_in_offer_app`]="{ column }">
                        <span class="header-title-wrap mr-1">
                            {{ column.title }}
                        </span>
                        <v-icon
                            style="cursor: pointer;"
                            size="small"
                            :color="selectedVisibleInOfferFilter !== null ? 'primary' : undefined"
                            class="fas fa-chevron-down">
                            <v-menu
                                activator="parent"
                                :close-on-content-click="true"
                                class="table-dropdown-menu">
                                <v-card
                                    variant="outlined"
                                    style="min-width: 4.5cm; display: flex; flex-direction: column;">
                                    <v-list style="list-style: none;" density="compact">
                                        <v-list-item
                                            v-for="option in visibleInOfferFilterOptions"
                                            :key="String(option.value)"
                                            :active="selectedVisibleInOfferFilter === option.value"
                                            active-class="active-item"
                                            @click="selectedVisibleInOfferFilter = option.value">
                                            {{ option.title }}
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-menu>
                        </v-icon>
                    </template>
                    <template v-slot:[`item.visible_in_offer_app`]="{ item }">
                        <div class="d-flex justify-center">
                            <v-checkbox
                                :model-value="getVisibleInOfferChecked(item)"
                                density="compact"
                                hide-details
                                color="primary"
                                class="ma-0 pa-0"
                                :disabled="!canManagePriceList || isVisibleInOfferSaving(item) || Boolean(item.is_multi_furnizor_child)"
                                @click.stop
                                @update:model-value="
                                    value => onVisibleInOfferToggleRequest(item, value)
                                "
                            />
                        </div>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <div class="products-row-actions">
                            <v-icon
                                v-if="canManagePriceList && !item.is_multi_furnizor_child"
                                size="small"
                                color="primary"
                                title="Compară furnizori"
                                @click="openSupplierCompare(item)">
                                mdi-scale-balance
                            </v-icon>
                            <v-icon
                                v-if="canUsePriceListEditor && canEditPriceListItem(item)"
                                size="small"
                                :color="draftProductCodeSet.has(item.product_code) ? 'warning' : 'primary'"
                                @click="editItem(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                v-if="canManagePriceList && !item.is_multi_furnizor_child"
                                size="small"
                                color="danger"
                                @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </div>
                    </template>
                    <template v-slot:no-data>
                        <v-btn v-if="productsPanelExpanded" color="primary" @click="resetFiltersAndReload">
                            Reset
                        </v-btn>
                    </template>
                </v-data-table-server>
            </v-locale-provider>
        </v-card-item>
        <v-dialog
            v-model="dialogVisibleInOfferConfirm"
            width="520"
            :fullscreen="$vuetify.display.smAndDown">
            <v-card>
                <v-card-title class="text-h6">
                    Confirmă vizibilitatea în programul de ofertare
                </v-card-title>
                <v-card-text>
                    <p class="mb-2">
                        Ești sigur că vrei să
                        <strong>
                            {{
                                visibilityConfirmNextValue
                                    ? 'faci vizibil'
                                    : 'ascunzi'
                            }}
                        </strong>
                        produsul în programul de ofertare?
                    </p>
                    <p v-if="visibilityConfirmItem" class="mb-0 text-medium-emphasis">
                        <strong>{{ visibilityConfirmItem.product_code }}</strong>
                        —
                        {{ visibilityConfirmItem.product_name }}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="primary"
                        variant="text"
                        @click="closeVisibleInOfferConfirm">
                        Anulează
                    </v-btn>
                    <v-btn
                        color="primary"
                        variant="text"
                        :loading="Boolean(visibilityConfirmItem?._visibleInOfferSaving)"
                        @click="confirmVisibleInOfferToggle">
                        Confirmă
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogCalculationRequiredConfirm"
            width="560"
            :fullscreen="$vuetify.display.smAndDown">
            <v-card>
                <v-card-title class="text-h6 d-flex align-center ga-2">
                    <v-icon color="error" size="26">
                        mdi-alert-octagon
                    </v-icon>
                    Atenție — produs folosit în calcule
                </v-card-title>
                <v-card-text>
                    <p class="mb-2">
                        Acest produs face parte din cataloagele folosite la
                        <strong>Calculează produse</strong>
                        în ofertare
                        <template v-if="calculationRequiredInfo?.catalogs?.length">
                            ({{ calculationRequiredInfo.catalogs.join(', ') }})
                        </template>.
                        Continuați?
                    </p>
                    <p
                        v-if="editedItem?.product_code"
                        class="mb-0 text-medium-emphasis">
                        <strong>{{ editedItem.product_code }}</strong>
                        —
                        {{
                            calculationRequiredInfo?.name
                                || editedItem.product_name
                        }}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="primary"
                        variant="text"
                        @click="closeCalculationRequiredConfirm">
                        Renunță
                    </v-btn>
                    <v-btn
                        color="warning"
                        variant="tonal"
                        :loading="
                            pendingCalculationAction === 'anulat' && markingAsAnulat
                        "
                        @click="confirmCalculationRequiredAction">
                        Confirmă
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <a v-if="canManagePriceList" href="#" id="section3" ref="section3"></a>
        <v-card-item v-if="canManagePriceList && selectedPriceList">
            <PriceListHistoryLog
                ref="priceListHistory"
                :price-list-id="selectedPriceList"
                :key="selectedPriceList"
            />
        </v-card-item>
        <PriceListProductBuilderModal
            v-if="canUsePriceListEditor"
            v-model="builderDialog"
            :edit-item="builderEditItem"
            :draft-entry="builderDraftEntry"
            :price-lists="priceLists"
            :selected-price-list="selectedPriceList"
            :pricing-settings="listPricingSettings"
            :existing-product-codes="items.map(item => item.product_code)"
            :existing-products="items"
            :product-drafts="productDrafts"
            :blocked-draft-product-codes="blockedDraftProductCodes"
            :measurement-units="measurementUnits"
            :saving-draft="builderSavingDraft"
            :saving-direct="builderSavingDirect"
            :read-only="builderReadOnly"
            :compare-changes="builderCompareChanges"
            :compare-furnizor-tab-key="builderCompareFurnizorTabKey"
            :compare-reference-payload="builderCompareReferencePayload"
            :initial-furnizor-tab-key="builderInitialFurnizorTabKey"
            :status-locked-to-de-verificat="isPriceListVerifier"
            :allow-direct-save="canManagePriceList"
            @draft-save="onBuilderDraftSave"
            @save-direct="onBuilderSaveDirect" />
        <PriceListBulkPropertyDialog
            v-if="canManagePriceList"
            v-model="bulkPropertyDialogOpen"
            :items="items"
            :selected-price-list="selectedPriceList"
            :price-lists="priceLists"
            :pricing-settings="listPricingSettings"
            :measurement-units="measurementUnits"
            :saving="bulkPropertySaving"
            :applying="bulkPropertyApplying"
            @add-drafts="onBulkPropertyDrafts"
            @apply-direct="onBulkPropertyDirect" />
        <PriceListTargetDialog
            v-if="canManagePriceList"
            v-model="publishDraftsDialog"
            :price-lists="priceLists"
            :price-list-type="selectedPriceListType"
            :default-price-list-id="selectedPriceList"
            :copy-from-price-list-id="selectedPriceList"
            :loading="publishingDrafts"
            title="Aplică lista în lucru"
            :description="publishDraftsDialogDescription"
            confirm-label="Aplică lista în lucru"
            @confirm="publishProductDrafts" />
        <PriceListCompareDialog
            v-if="canManagePriceList"
            v-model="compareDialog"
            :price-lists="priceLists"
            @view-product="onCompareViewProduct" />
        <PriceListSupplierCompareDialog
            v-if="canManagePriceList"
            v-model="supplierCompareDialog"
            :products="items"
            :product-drafts="productDrafts"
            :initial-product-codes="supplierCompareProductCodes"
            :reference-product-code="supplierCompareReferenceCode"
            :price-list-type="selectedPriceListType"
            :price-list-id="selectedPriceList"
            :pricing-settings="listPricingSettings"
            :price-lists="priceLists"
            :measurement-units="measurementUnits" />
    </v-card>
</template>

<script>
import apiClient from "@/utils/apiClient";
import {
    MAIN_PRODUCT_CATEGORIES,
    getCategoryColor,
    getCategoryLabel,
    getCategoryShortLabel,
    getProductMainCategories,
    normalizeSystemValue,
} from "@/data/productCategories";
import {
    buildProductStatusFilterOptions,
    formatProductStatus,
    getProductStatusTextStyle,
    normalizeProductStatus,
} from "@/data/productStatus";
import {
    findChapterByCode,
    findSubchapterByCode,
    getChapterDisplayName,
    getChapterName,
    getSubchapterName,
    listAllChapters,
    normalizeChapterCode,
    padSubchapterCode,
} from "@/data/productStructureLookups";
import { ensureProductLookupsLoaded } from "@/utils/productLookupApi";
import { parseProductCodeStructure } from "@/utils/productStructureHelpers";
import {
    extractPriceListNotificationChanges,
    notifyPriceListChanges,
} from "@/utils/priceListNotification";
import {
    formatNumber,
    formatRonPrice,
    priceListSelectTitle,
    showAlertModal,
    sortByProductCode,
} from "@/utils/utils";
import { applyDraftDefaultFurnizor, resolveProductNotes } from "@/utils/priceListTablePricing";
import {
    expandLiveProductDisplayItems,
    resolveSourceProductItem,
    sortLiveDisplayRowsByKey,
    withMultiFurnizorGroupSort,
} from "@/utils/priceListLiveDisplayRows";
import {cloneDeep} from "lodash";
import {mapGetters} from "vuex";
import PriceListProductBuilderModal from "@/components/pricelist/PriceListProductBuilderModal.vue";
import PriceListDraftPanel from "@/components/pricelist/PriceListDraftPanel.vue";
import PriceListBulkPropertyDialog from "@/components/pricelist/PriceListBulkPropertyDialog.vue";
import PriceListTargetDialog from "@/components/pricelist/PriceListTargetDialog.vue";
import PriceListCompareDialog from "@/components/pricelist/PriceListCompareDialog.vue";
import PriceListSupplierCompareDialog from "@/components/pricelist/PriceListSupplierCompareDialog.vue";
import PriceListHistoryLog from "@/components/pricelist/PriceListHistoryLog.vue";
import {
    createDraftEntry,
    findDraftByProductCode,
    getDraftProductCodes,
    resolveDraftAction,
    fetchDraftQueue,
    saveDraftEntry,
    migrateDraftEntry,
    deleteDraftEntry,
    clearDraftQueue,
    resolvePersistedDraftId,
} from "@/utils/priceListDraftQueue";
import {
    applyPendingListPriceToItem,
    resolvePendingUpdateFromRow,
} from "@/utils/priceListSimpleUpdate";
import {
    DEFAULT_PRICING_SETTINGS,
    formatPercentValue,
    mergeListPricingSettings,
    parseNumericInput,
    resolveAppliedDiscountsDisplay,
} from "@/utils/priceListProductCalculator";
import {
    buildPropagateDrafts,
    resolvePropagatePeerItem,
} from "@/utils/priceListPropagateFurnizor";
import { findCalculationRequiredProduct } from "@/utils/priceListVerification";
import { getFurnizori } from "@/data/furnizorNames";

const PRODUCTS_ITEMS_PER_PAGE_OPTIONS = [
    { value: 25, title: '25' },
    { value: 50, title: '50' },
    { value: 100, title: '100' },
];

/** Sentinel value for filtering products that have 2+ furnizori. */
const FURNIZOR_FILTER_MULTIPLE = '__multiple_furnizori__';

export default {
    components: {
        PriceListProductBuilderModal,
        PriceListDraftPanel,
        PriceListBulkPropertyDialog,
        PriceListTargetDialog,
        PriceListCompareDialog,
        PriceListSupplierCompareDialog,
        PriceListHistoryLog,
    },
    data() {
        return {
            MAIN_PRODUCT_CATEGORIES,
            calculatedHeight: "calc(100vh - 64px)", // Initial value
            tableMaxHeightPx: Math.max(200, (typeof window !== 'undefined' ? window.innerHeight : 800) - 198),
            sidebarLinks: [
                {
                    name: "Listă de prețuri",
                    link: "#section1",
                    id: "section1",
                },
                {
                    name: "Listă în lucru",
                    link: "#section-drafts",
                    id: "section-drafts",
                },
                {
                    name: "Listă de produse",
                    link: "#section2",
                    id: "section2",
                },
                {
                    name: "Istoric",
                    link: "#section3",
                    id: "section3",
                },
            ],
            builderDialog: false,
            builderEditItem: null,
            builderDraftEntry: null,
            builderSavingDraft: false,
            builderSavingDirect: false,
            draftSaving: false,
            directApplying: false,
            bulkPropertyDialogOpen: false,
            bulkPropertySaving: false,
            bulkPropertyApplying: false,
            productDrafts: [],
            publishingDrafts: false,
            publishDraftsDialog: false,
            draftIdsToPublish: [],
            compareDialog: false,
            supplierCompareDialog: false,
            supplierCompareProductCodes: [],
            supplierCompareReferenceCode: '',
            builderReadOnly: false,
            builderCompareChanges: [],
            builderCompareFurnizorTabKey: null,
            builderCompareReferencePayload: null,
            builderInitialFurnizorTabKey: null,
            productsPanelExpanded: true,
            /** Product ids with multi-furnizor rows expanded (collapsed by default). */
            expandedMultiFurnizorProductIds: {},
            dialogDelete: false,
            dialogDeleteChoice: false,
            dialogCalculationRequiredConfirm: false,
            markingAsAnulat: false,
            deleteConfirmText: '',
            calculationRequiredInfo: null,
            /** @type {'anulat'|'delete'|null} */
            pendingCalculationAction: null,
            /** Skip editedItem reset while switching delete → list-removal dialog. */
            deferDeleteItemReset: false,
            productsPage: 1,
            productsItemsPerPage: 50,
            productsTotalCount: 0,
            productsItemsPerPageOptions: PRODUCTS_ITEMS_PER_PAGE_OPTIONS,
            /** Client sort for current page (v-data-table-server does not apply sortRaw). */
            productsSortBy: [],
            productsFilterReloadTimer: null,
            suppressProductsFilterWatch: false,
            headers: [
                {title: 'Serial nr.', key: 'serial_number', align: 'center', sortable: true},
                {
                    title: 'Vizibil program ofertare',
                    key: 'visible_in_offer_app',
                    align: 'center',
                    sortable: true,
                    headerProps: { class: 'header-wrap' },
                },
                {title: 'Furnizor', key: 'furnizor', align: 'start', sortable: true},
                {title: 'Cod produs', key: 'product_code', align: 'center', sortable: true},
                {
                    title: 'Denumire comercială',
                    key: 'product_name',
                    align: 'start',
                    sortable: true,
                    headerProps: { class: 'product-name-header' },
                    cellProps: { class: 'product-name-cell' },
                },
                {title: 'Status', key: 'status', align: 'center', sortable: true},
                {title: 'Sisteme', key: 'categories', align: 'center', sortable: false},
                {title: 'U.M.', key: 'measurement_unit', align: 'center', sortable: true},
                {
                    title: 'Preț listă furnizor',
                    key: 'supplier_list_price',
                    align: 'center',
                    sortable: true,
                    headerProps: { class: 'header-wrap' },
                },
                {
                    title: 'Discount',
                    key: 'has_discounts',
                    align: 'center',
                    sortable: true,
                },
                {
                    title: 'Cost transport',
                    key: 'transport_cost_rate',
                    align: 'center',
                    sortable: true,
                    headerProps: { class: 'header-wrap' },
                },
                {
                    title: 'Preț achiziție final fără TVA',
                    key: 'entry_price_ron_inc_vat',
                    align: 'center',
                    sortable: true,
                    headerProps: { class: 'header-wrap' },
                },
                {
                    title: 'Adaos referință',
                    key: 'markup_reference',
                    align: 'center',
                    sortable: true,
                    headerProps: { class: 'header-wrap' },
                },
                {
                    title: 'Adaos actual',
                    key: 'markup_actual',
                    align: 'center',
                    sortable: true,
                    headerProps: { class: 'header-wrap' },
                },
                {
                    title: 'Preț vânzare fără TVA',
                    key: 'price_ex_vat',
                    align: 'center',
                    sortable: true,
                    headerProps: { class: 'header-wrap' },
                },
                {
                    title: 'Preț vânzare cu TVA',
                    key: 'price',
                    align: 'center',
                    sortable: true,
                    headerProps: { class: 'header-wrap' },
                },
                {title: 'Note', key: 'notes', align: 'center', sortable: false},
                {
                    title: 'Acțiuni',
                    key: 'actions',
                    sortable: false,
                    align: 'center',
                    headerProps: { class: 'header-nowrap' },
                    cellProps: { class: 'actions-cell' },
                },
            ],
            items: [],
            editedItem: {
                product_code: "",
                price_list_ids: {},
            },
            defaultItem: {
                product_code: "",
                price_list_ids: {},
            },
            measurementUnits: [
                { text: "m²", value: "m²", number: 1 },
                { text: "m", value: "m", number: 2 },
                { text: "pungă", value: "pungă", number: 3 },
                { text: "buc", value: "buc", number: 4 },
                { text: "l", value: "l", number: 5 },
                { text: "set", value: "set", number: 6 },
                { text: "cutie", value: "cutie", number: 7 },
                { text: "rolă", value: "rolă", number: 8 },
                { text: "km", value: "km", number: 9 },
                { text: "kg", value: "kg", number: 10 },
                { text: "ora", value: "ora", number: 11 },
            ],
            priceLists: [],
            selectedPriceList: null,
            loading: false,
            search: '',
            selectedSystemFilter: null,
            sistemSearch: '',
            selectedFurnizorFilter: null,
            furnizorSearch: '',
            structureFilterMenuOpen: false,
            // Bumped after /api/product-structure/ loads so Categorie filters recompute.
            productLookupsVersion: 0,
            selectedChapterFilter: null,
            selectedSubchapterFilter: null,
            selectedVisibleInOfferFilter: null,
            selectedStatusFilter: null,
            markupActualFilterOp: null,
            markupActualFilterPercent: null,
            markupReferenceFilterOp: null,
            markupReferenceFilterPercent: null,
            markupFilterOpOptions: [
                { title: 'Toate', value: null },
                { title: 'Mai mare decât', value: 'gt' },
                { title: 'Mai mic decât', value: 'lt' },
            ],
            markupActualFilterOpOptions: [
                { title: 'Toate', value: null },
                { title: 'Mai mare decât', value: 'gt' },
                { title: 'Mai mic decât', value: 'lt' },
                { title: 'Mai mic decât adaos de referință', value: 'lt_ref' },
                { title: 'Mai mare decât adaos de referință', value: 'gt_ref' },
            ],
            visibleInOfferFilterOptions: [
                { title: 'Toate', value: null },
                { title: 'Vizibile', value: true },
                { title: 'Nevizibile', value: false },
            ],
            dialogVisibleInOfferConfirm: false,
            visibilityConfirmItem: null,
            visibilityConfirmNextValue: null,
            selectedPriceListType: 'general',
            groupedPriceLists: {},
            listPricingSettingsForm: {
                exchangeRateEur: String(
                    DEFAULT_PRICING_SETTINGS.exchangeRateEur,
                ),
                exchangeRatePln: String(
                    DEFAULT_PRICING_SETTINGS.exchangeRatePln,
                ),
                exchangeRateUsd: String(
                    DEFAULT_PRICING_SETTINGS.exchangeRateUsd,
                ),
            },
            savingListPricingSettings: false,
        };
    },
    computed: {
        ...mapGetters(['userPermissions']),
        statusFilterOptions() {
            return buildProductStatusFilterOptions(this.items || []);
        },
        canConfirmDelete() {
            const typed = String(this.deleteConfirmText || '')
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(/\p{M}/gu, '');
            return typed === 'sterge';
        },
        canManagePriceList() {
            return Boolean(this.userPermissions?.priceListManagement?.canManagePriceList);
        },
        canVerifyPriceListProducts() {
            return Boolean(this.userPermissions?.priceListManagement?.canVerifyPriceListProducts);
        },
        canUsePriceListEditor() {
            return this.canManagePriceList || this.canVerifyPriceListProducts;
        },
        canViewFullPriceList() {
            return this.canManagePriceList || this.canVerifyPriceListProducts;
        },
        isPriceListVerifier() {
            return this.canVerifyPriceListProducts && !this.canManagePriceList;
        },
        isAgentPriceListView() {
            return Boolean(this.userPermissions?.priceListManagement?.canViewPriceListPage)
                && !this.canUsePriceListEditor;
        },
        displaySidebarLinks() {
            if (this.isAgentPriceListView) {
                return [{
                    name: "Listă de produse",
                    link: "#section2",
                    id: "section2",
                }];
            }
            return this.sidebarLinks;
        },
        tableHeaders() {
            const groupSortOptions = { sortByProductCode };
            if (this.isAgentPriceListView) {
                return withMultiFurnizorGroupSort([
                    { title: 'Cod produs', key: 'product_code', align: 'center', sortable: true },
                    {
                        title: 'Denumire comercială',
                        key: 'product_name',
                        align: 'start',
                        sortable: true,
                        headerProps: { class: 'product-name-header' },
                        cellProps: { class: 'product-name-cell' },
                    },
                    { title: 'Sisteme', key: 'categories', align: 'center', sortable: false },
                    { title: 'U.M.', key: 'measurement_unit', align: 'center', sortable: true },
                    {
                        title: 'Preț vânzare fără TVA',
                        key: 'price_ex_vat',
                        align: 'center',
                        sortable: true,
                        headerProps: { class: 'header-wrap' },
                    },
                    {
                        title: 'Preț vânzare cu TVA',
                        key: 'price',
                        align: 'center',
                        sortable: true,
                        headerProps: { class: 'header-wrap' },
                    },
                ], groupSortOptions);
            }
            return withMultiFurnizorGroupSort(this.headers, groupSortOptions);
        },
        priceListTypes() {
            return Object.values(this.$store.state.PRICE_LIST_TYPES).filter(
                type => type.isActive,
            );
        },
        blockedDraftProductCodes() {
            return getDraftProductCodes(
                this.productDrafts,
                this.builderDraftEntry?.id,
            );
        },
        draftProductCodeSet() {
            const codes = new Set();
            for (const draft of this.productDrafts) {
                const code = String(draft.payload?.product_code || "").trim();
                if (code) {
                    codes.add(code);
                }
            }
            return codes;
        },
        filteredItems() {
            // Search / status / system / furnizor / structure / visibility are
            // applied server-side with pagination. Keep only page-local markup filters.
            let result = this.items;

            if (this.hasMarkupActualFilter) {
                const op = this.markupActualFilterOp;
                if (op === 'lt_ref' || op === 'gt_ref') {
                    result = result.filter((item) => this.matchesMarkupActualVsReference(item, op));
                } else {
                    const thresholdRatio = parseNumericInput(this.markupActualFilterPercent) / 100;
                    result = result.filter((item) => {
                        if (
                            item.markup_actual === null
                            || item.markup_actual === undefined
                            || item.markup_actual === ''
                        ) {
                            return false;
                        }
                        const actual = parseNumericInput(item.markup_actual);
                        if (op === 'lt') {
                            return actual < thresholdRatio;
                        }
                        return actual > thresholdRatio;
                    });
                }
            }

            if (this.hasMarkupReferenceFilter) {
                const thresholdRatio = parseNumericInput(this.markupReferenceFilterPercent) / 100;
                const op = this.markupReferenceFilterOp;
                result = result.filter((item) => {
                    if (
                        item.markup_reference === null
                        || item.markup_reference === undefined
                        || item.markup_reference === ''
                    ) {
                        return false;
                    }
                    const reference = parseNumericInput(item.markup_reference);
                    if (op === 'lt') {
                        return reference < thresholdRatio;
                    }
                    return reference > thresholdRatio;
                });
            }

            return result;
        },
        /**
         * Filtered products expanded into display rows for multi-furnizor groups.
         * Collapsed (default): only the implicit furnizor row, as before.
         */
        displayItems() {
            if (this.isAgentPriceListView) {
                return this.filteredItems;
            }
            return expandLiveProductDisplayItems(this.filteredItems, {
                expandedProductIds: this.expandedMultiFurnizorProductIds,
                pricingSettings: this.listPricingSettings,
            });
        },
        /**
         * Current-page rows in table order. Server table never reorders :items,
         * so we apply productsSortBy here (multi-furnizor groups stay contiguous).
         */
        sortedDisplayItems() {
            const rows = this.displayItems;
            const sort = Array.isArray(this.productsSortBy) && this.productsSortBy[0];
            if (!sort?.key) {
                return rows;
            }
            return sortLiveDisplayRowsByKey(
                rows,
                sort.key,
                sort.order,
                { sortByProductCode },
            );
        },
        /**
         * Cap table body to viewport when many rows; shrink to content when few
         * (avoids a large empty gap with the footer stuck at the bottom).
         */
        productsTableHeight() {
            if (!this.productsPanelExpanded) {
                return 0;
            }
            const itemsPerPage = Number(this.productsItemsPerPage) || 50;
            const visibleRows = Math.min(this.sortedDisplayItems.length, itemsPerPage);
            if (visibleRows <= 0) {
                return undefined;
            }
            // Multi-line headers + compact rows that can include chips
            const headerPx = 100;
            const rowPx = 72;
            const estimatedContentPx = headerPx + visibleRows * rowPx;
            if (estimatedContentPx < this.tableMaxHeightPx) {
                return undefined;
            }
            return `${this.tableMaxHeightPx}px`;
        },
        productsTableFixedHeader() {
            return Boolean(this.productsTableHeight);
        },
        isMarkupActualVsRefFilter() {
            return this.markupActualFilterOp === 'lt_ref'
                || this.markupActualFilterOp === 'gt_ref';
        },
        hasMarkupActualFilter() {
            if (!this.markupActualFilterOp) {
                return false;
            }
            if (this.isMarkupActualVsRefFilter) {
                return true;
            }
            return (
                this.markupActualFilterPercent !== null
                && this.markupActualFilterPercent !== undefined
                && String(this.markupActualFilterPercent).trim() !== ''
            );
        },
        hasMarkupReferenceFilter() {
            if (!this.markupReferenceFilterOp) {
                return false;
            }
            return (
                this.markupReferenceFilterPercent !== null
                && this.markupReferenceFilterPercent !== undefined
                && String(this.markupReferenceFilterPercent).trim() !== ''
            );
        },
        categoryFilterOptions() {
            // Always expose the canonical Sistem list (incl. FOTOVOLTAICE),
            // plus any extra categories found on current products.
            const names = new Set(
                MAIN_PRODUCT_CATEGORIES.map((category) => category.value),
            );
            for (const item of this.items) {
                for (const categoryName of getProductMainCategories(item)) {
                    names.add(categoryName);
                }
            }

            return Array.from(names)
                .sort((a, b) =>
                    getCategoryLabel(a).localeCompare(
                        getCategoryLabel(b),
                        "ro",
                    ),
                )
                .map(name => ({
                    title: getCategoryLabel(name),
                    value: name,
                }));
        },
        multipleFurnizoriFilterValue() {
            return FURNIZOR_FILTER_MULTIPLE;
        },
        furnizorFilterOptions() {
            const names = new Set(
                getFurnizori()
                    .map((row) => String(row?.name || row?.title || '').trim())
                    .filter(Boolean),
            );
            return Array.from(names)
                .sort((a, b) => a.localeCompare(b, 'ro'))
                .map((name) => ({
                    title: name,
                    value: name,
                }));
        },
        furnizorFilterOptionsFiltered() {
            const q = String(this.furnizorSearch || '').trim().toLowerCase();
            if (!q) return this.furnizorFilterOptions;
            return this.furnizorFilterOptions.filter((o) =>
                o.title.toLowerCase().includes(q),
            );
        },
        categoryFilterOptionsFiltered() {
            const q = String(this.sistemSearch || '').trim().toLowerCase();
            if (!q) return this.categoryFilterOptions;
            return this.categoryFilterOptions.filter((o) =>
                o.title.toLowerCase().includes(q),
            );
        },
        chapterFilterOptions() {
            // Full Admin catalog (not only categories present on current rows).
            void this.productLookupsVersion;
            return listAllChapters()
                .map((chapter) => {
                    const code = normalizeChapterCode(chapter.code);
                    if (!code) {
                        return null;
                    }
                    const name = String(chapter.name || '').trim();
                    return {
                        title: name && name !== code ? `${code} – ${name}` : code,
                        value: code,
                    };
                })
                .filter(Boolean);
        },
        subchapterFilterOptions() {
            // Subcategorii only for the selected Categorie (full catalog for that chapter).
            void this.productLookupsVersion;
            const selectedChapter = normalizeChapterCode(this.selectedChapterFilter);
            if (!selectedChapter) {
                return [];
            }
            const chapter = findChapterByCode(selectedChapter);
            if (!chapter) {
                return [];
            }

            return Object.entries(chapter.subchapters || {})
                .map(([rawCode, rawName]) => {
                    const code = padSubchapterCode(rawCode);
                    if (!code) {
                        return null;
                    }
                    const name = String(rawName || '').trim();
                    return {
                        title: name && name !== code ? `${code} – ${name}` : code,
                        value: `${code}::${name || code}`,
                        sortCode: code,
                        name: name || code,
                    };
                })
                .filter(Boolean)
                .sort((a, b) => (
                    Number(a.sortCode) - Number(b.sortCode)
                    || String(a.name).localeCompare(String(b.name), 'ro')
                ));
        },
        structureFilterDisplay() {
            const parts = [];

            const chapterTitle = this.selectedChapterFilter
                ? (
                    this.chapterFilterOptions
                        .find((option) => option.value === this.selectedChapterFilter)?.title
                    || this.selectedChapterFilter
                )
                : '';
            const subchapterTitle = this.selectedSubchapterFilter
                ? (
                    this.subchapterFilterOptions
                        .find((option) => option.value === this.selectedSubchapterFilter)?.title
                    || this.selectedSubchapterFilter
                )
                : '';

            if (chapterTitle && subchapterTitle) {
                parts.push(`${chapterTitle} › ${subchapterTitle}`);
            } else if (chapterTitle) {
                parts.push(chapterTitle);
            } else if (subchapterTitle) {
                parts.push(subchapterTitle);
            }

            return parts.join(' · ');
        },
        listPricingSettings() {
            const record = this.priceLists.find(
                priceList => priceList.id === this.selectedPriceList,
            );
            const saved = mergeListPricingSettings(record?.pricing_settings);
            return {
                ...saved,
                exchangeRateEur:
                    parseNumericInput(
                        this.listPricingSettingsForm.exchangeRateEur,
                    ) || saved.exchangeRateEur,
                exchangeRatePln:
                    parseNumericInput(
                        this.listPricingSettingsForm.exchangeRatePln,
                    ) || saved.exchangeRatePln,
                exchangeRateUsd:
                    parseNumericInput(
                        this.listPricingSettingsForm.exchangeRateUsd,
                    ) || saved.exchangeRateUsd,
            };
        },
        publishDraftsDialogDescription() {
            const selectedIds = new Set(
                (this.draftIdsToPublish || []).map((id) => String(id)),
            );
            const selectedCount = selectedIds.size
                ? this.productDrafts.filter((draft) => (
                    selectedIds.has(String(draft.id))
                )).length
                : this.productDrafts.length;
            const remaining = this.productDrafts.length - selectedCount;
            if (!selectedCount) {
                return "";
            }
            const selectedLabel = `${selectedCount} produs${
                selectedCount === 1 ? "" : "e"
            } selectat${selectedCount === 1 ? "" : "e"}`;
            if (remaining > 0) {
                return `${selectedLabel} vor fi aplicate doar în lista selectată. Celelalte ${remaining} rămân în lista în lucru.`;
            }
            return `${selectedLabel} vor fi aplicate doar în lista selectată.`;
        },
    },
    watch: {
        dialogDelete(val) {
            if (!val) {
                this.resetEditedItemIfDeleteDialogsClosed();
            }
        },
        dialogDeleteChoice(val) {
            if (!val) {
                this.resetEditedItemIfDeleteDialogsClosed();
            }
        },
        dialogCalculationRequiredConfirm(val) {
            if (!val) {
                this.resetEditedItemIfDeleteDialogsClosed();
            }
        },
        dialogVisibleInOfferConfirm(val) {
            if (!val) {
                this.visibilityConfirmItem = null;
                this.visibilityConfirmNextValue = null;
            }
        },
        async selectedPriceListType() {
            if (this.isAgentPriceListView) {
                return;
            }
            await this.onPriceListTypeChange();
            if (this.selectedPriceList) {
                await this.initializePriceLists();
            }
            this.loadProductDrafts();
        },
        selectedPriceList() {
            this.syncListPricingSettingsForm();
            if (this.canUsePriceListEditor) {
                this.loadProductDrafts();
            }
        },
        search() {
            if (this.suppressProductsFilterWatch) return;
            this.scheduleProductsReload({ resetPage: true });
        },
        selectedSystemFilter() {
            if (this.suppressProductsFilterWatch) return;
            this.scheduleProductsReload({ resetPage: true });
        },
        selectedFurnizorFilter() {
            if (this.suppressProductsFilterWatch) return;
            this.scheduleProductsReload({ resetPage: true });
        },
        selectedChapterFilter() {
            if (this.suppressProductsFilterWatch) return;
            this.scheduleProductsReload({ resetPage: true });
        },
        selectedSubchapterFilter() {
            if (this.suppressProductsFilterWatch) return;
            this.scheduleProductsReload({ resetPage: true });
        },
        selectedVisibleInOfferFilter() {
            if (this.suppressProductsFilterWatch) return;
            this.scheduleProductsReload({ resetPage: true });
        },
        selectedStatusFilter() {
            if (this.suppressProductsFilterWatch) return;
            this.scheduleProductsReload({ resetPage: true });
        },
        builderDialog(isOpen) {
            if (!isOpen) {
                this.clearBuilderContext();
            }
        },
    },
    async created() {
        if (this.isAgentPriceListView) {
            this.selectedPriceListType = 'general';
        }
        try {
            await ensureProductLookupsLoaded();
        } finally {
            this.productLookupsVersion += 1;
        }
        await this.initializePriceLists();
        if (this.canUsePriceListEditor) {
            this.loadProductDrafts();
        }
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyDown);
        this.calculateHeight();
    },
    methods: {
        async initializePriceLists() {
            if (this.isAgentPriceListView) {
                this.selectedPriceListType = 'general';
            }
            await this.getPriceLists();
            this.setCurrentPriceList();
            await this.initialize();
            this.$store.state.sidebarLinks = this.displaySidebarLinks;
        },
        /**
         * Handles the keyboard shortcut for opening the add product dialog (Ctrl+A).
         *
         * @param {KeyboardEvent} event
         */
        handleKeyDown(event) {
            if (!this.canUsePriceListEditor) {
                return;
            }
            if (!this.builderDialog && event.ctrlKey && event.key === "a") {
                event.preventDefault();
                this.openBuilderDialog();
            }
        },
        toggleProductsPanel() {
            this.productsPanelExpanded = !this.productsPanelExpanded;
            if (!this.productsPanelExpanded) {
                this.structureFilterMenuOpen = false;
            }
            this.$nextTick(() => {
                this.calculateHeight();
            });
        },
        productRowProps({ item }) {
            const classes = [];
            if (item?.has_multiple_furnizori && !item?.is_multi_furnizor_child) {
                classes.push('product-row--multi-furnizor');
            }
            if (item?.is_multi_furnizor_child) {
                classes.push('product-row--furnizor-child');
            }
            const groupPos = item?.multi_furnizor_group_pos;
            if (groupPos === 'start') {
                classes.push('product-row--furnizor-group-start');
            } else if (groupPos === 'middle') {
                classes.push('product-row--furnizor-group-middle');
            } else if (groupPos === 'end') {
                classes.push('product-row--furnizor-group-end');
            }
            return classes.length ? { class: classes.join(' ') } : {};
        },
        /**
         * @param {Object} item
         * @returns {boolean}
         */
        isMultiFurnizorExpanded(item) {
            const source = resolveSourceProductItem(item);
            const id = source?.id;
            if (id == null) {
                return false;
            }
            return Boolean(this.expandedMultiFurnizorProductIds[String(id)]);
        },
        /**
         * @param {Object} item
         */
        toggleMultiFurnizorExpand(item) {
            const source = resolveSourceProductItem(item);
            const id = source?.id;
            if (id == null || !item?.has_multiple_furnizori || item?.is_multi_furnizor_child) {
                return;
            }
            const key = String(id);
            if (this.expandedMultiFurnizorProductIds[key]) {
                const next = { ...this.expandedMultiFurnizorProductIds };
                delete next[key];
                this.expandedMultiFurnizorProductIds = next;
            } else {
                this.expandedMultiFurnizorProductIds = {
                    ...this.expandedMultiFurnizorProductIds,
                    [key]: true,
                };
            }
        },
        /**
         * Dynamically calculates and updates the height of the product table based on the toolbar height.
         */
        calculateHeight() {
            // Ensure the toolbarRef is available and has been rendered
            if (this.$refs.toolbarRef) {
                const toolbarHeight = this.$refs.toolbarRef.clientHeight;
                const maxHeightPx = Math.max(
                    200,
                    window.innerHeight - 134 - toolbarHeight,
                );
                this.tableMaxHeightPx = maxHeightPx;
                this.calculatedHeight = `${maxHeightPx}px`;
            }
        },
        formatNumber,
        formatRonPrice,
        formatPercentOrDash(value) {
            if (value === null || value === undefined || value === '') {
                return '—';
            }
            return formatPercentValue(value) || '—';
        },
        getProductNotes(item) {
            return resolveProductNotes(item);
        },
        sortByProductCode,
        getCategoryColor,
        getCategoryShortLabel,
        getProductMainCategories,
        priceListItemTitle(item) {
            return priceListSelectTitle(item);
        },
        /**
         * Resolves chapter/subchapter (Categorie/Subcategorie) for a product from pricing detail or product code.
         * @param {Object} item
         * @returns {{ chapterCode: string, chapterName: string, subchapterCode: string, subchapterName: string }|null}
         */
        getItemStructure(item) {
            const detail = item?.pricing_detail;
            const systems = getProductMainCategories(item);
            const preferredSystem = systems[0] || '';

            let chapterCode = normalizeChapterCode(detail?.chapterCode);
            let subchapterCode = padSubchapterCode(detail?.subchapterCode);
            let chapterName = String(detail?.chapterName || '').trim();
            let subchapterName = String(detail?.subchapterName || '').trim();
            const parsed = parseProductCodeStructure(item?.product_code);
            const parsedChapter = normalizeChapterCode(parsed?.chapterCode);
            const parsedSubchapter = padSubchapterCode(parsed?.subchapterCode);

            if (parsedChapter && getChapterDisplayName(parsedChapter) && !getChapterDisplayName(chapterCode)) {
                chapterCode = parsedChapter;
            }
            if (!chapterCode) {
                chapterCode = parsedChapter;
            }
            if (!subchapterCode) {
                subchapterCode = parsedSubchapter;
            }

            chapterCode = normalizeChapterCode(chapterCode);
            if (!chapterCode) {
                return null;
            }

            const catalogChapterName = getChapterDisplayName(chapterCode);
            if (
                catalogChapterName
                && (
                    !chapterName
                    || chapterName === String(detail?.chapterCode || '').trim()
                    || /^\d+$/.test(chapterName)
                )
            ) {
                chapterName = catalogChapterName;
            } else if (!chapterName || chapterName === String(detail?.chapterCode || '').trim()) {
                chapterName = this.resolveChapterName(chapterCode, preferredSystem);
            }
            if (subchapterCode && (!subchapterName || subchapterName === subchapterCode || /^\d+$/.test(subchapterName))) {
                subchapterName = this.resolveSubchapterName(chapterCode, subchapterCode, preferredSystem);
            }

            return {
                chapterCode,
                chapterName: chapterName || chapterCode,
                subchapterCode,
                subchapterName: subchapterName || subchapterCode,
            };
        },
        resolveChapterName(chapterCode, preferredSystem = '') {
            const catalogName = getChapterDisplayName(chapterCode);
            if (catalogName) {
                return catalogName;
            }
            if (preferredSystem) {
                const name = getChapterName(preferredSystem, chapterCode);
                if (name) {
                    return name;
                }
            }
            for (const category of MAIN_PRODUCT_CATEGORIES) {
                const name = getChapterName(category.value, chapterCode);
                if (name) {
                    return name;
                }
            }
            return '';
        },
        resolveSubchapterName(chapterCode, subchapterCode, preferredSystem = '') {
            const catalogName = findSubchapterByCode(chapterCode, subchapterCode)?.name || '';
            if (catalogName) {
                return catalogName;
            }
            if (preferredSystem) {
                const name = getSubchapterName(preferredSystem, chapterCode, subchapterCode);
                if (name) {
                    return name;
                }
            }
            for (const category of MAIN_PRODUCT_CATEGORIES) {
                const name = getSubchapterName(category.value, chapterCode, subchapterCode);
                if (name) {
                    return name;
                }
            }
            return '';
        },
        clearSystemFilter() {
            this.selectedSystemFilter = null;
        },
        clearFurnizorFilter() {
            this.selectedFurnizorFilter = null;
        },
        clearMarkupActualFilter() {
            this.markupActualFilterOp = null;
            this.markupActualFilterPercent = null;
        },
        clearMarkupReferenceFilter() {
            this.markupReferenceFilterOp = null;
            this.markupReferenceFilterPercent = null;
        },
        onMarkupActualFilterOpChange(op) {
            if (!op || op === 'lt_ref' || op === 'gt_ref') {
                this.markupActualFilterPercent = null;
            }
        },
        onMarkupReferenceFilterOpChange(op) {
            if (!op) {
                this.markupReferenceFilterPercent = null;
            }
        },
        toggleSystemFilter(value) {
            this.selectedSystemFilter = this.selectedSystemFilter === value
                ? null
                : value;
        },
        toggleFurnizorFilter(value) {
            this.selectedFurnizorFilter = this.selectedFurnizorFilter === value
                ? null
                : value;
        },
        toggleStatusFilter(value) {
            this.selectedStatusFilter = this.selectedStatusFilter === value
                ? null
                : value;
        },
        formatProductStatusLabel(value) {
            return formatProductStatus(value);
        },
        productStatusTextStyle(value) {
            return getProductStatusTextStyle(value);
        },
        itemMatchesSystemFilter(item) {
            const wanted = normalizeSystemValue(this.selectedSystemFilter);
            if (!wanted) {
                return true;
            }
            return getProductMainCategories(item).some(
                (categoryName) => normalizeSystemValue(categoryName) === wanted,
            );
        },
        itemMatchesFurnizorFilter(item) {
            const selected = this.selectedFurnizorFilter;
            if (!selected) {
                return true;
            }
            if (selected === FURNIZOR_FILTER_MULTIPLE) {
                return this.getItemFurnizorLabels(item).length >= 2;
            }
            const wanted = String(selected).trim().toLowerCase();
            return this.getItemFurnizorLabels(item).some(
                (row) => String(row?.label || '').trim().toLowerCase() === wanted,
            );
        },
        itemMatchesStructureFilter(item) {
            const structure = this.getItemStructure(item);
            if (!structure) {
                return false;
            }

            if (
                this.selectedChapterFilter
                && normalizeChapterCode(structure.chapterCode) !== normalizeChapterCode(this.selectedChapterFilter)
            ) {
                return false;
            }

            if (this.selectedSubchapterFilter) {
                const [code, ...nameParts] = String(this.selectedSubchapterFilter).split('::');
                const wantedCode = padSubchapterCode(code);
                const wantedName = nameParts.join('::').trim();
                if (wantedCode && padSubchapterCode(structure.subchapterCode) !== wantedCode) {
                    return false;
                }
                if (
                    wantedName
                    && String(structure.subchapterName || '').trim().toLocaleLowerCase('ro')
                        !== wantedName.toLocaleLowerCase('ro')
                ) {
                    return false;
                }
            }

            return true;
        },
        onChapterFilterChange() {
            const selected = this.selectedSubchapterFilter;
            if (!selected) {
                return;
            }
            const stillValid = this.subchapterFilterOptions.some(
                (option) => option.value === selected,
            );
            if (!stillValid) {
                this.selectedSubchapterFilter = null;
            }
        },
        onSubchapterFilterChange() {
            if (this.selectedSubchapterFilter) {
                this.structureFilterMenuOpen = false;
            }
        },
        clearStructureFilter() {
            this.selectedChapterFilter = null;
            this.selectedSubchapterFilter = null;
            this.structureFilterMenuOpen = false;
        },
        /**
         * @param {Object} item
         * @returns {{ label: string, isDefault: boolean, searchText: string }[]}
         */
        getItemFurnizorLabels(item) {
            const detail = item?.pricing_detail || {};
            const manufacturerName = String(detail.manufacturerName || '').trim();
            const pricings = Array.isArray(detail.furnizorPricings)
                ? detail.furnizorPricings
                : [];
            const defaultPricingId = detail.defaultFurnizorPricingId;

            if (!pricings.length) {
                const fallback = manufacturerName || String(item?.furnizor || '').trim();
                return fallback
                    ? [{ label: fallback, isDefault: true, searchText: fallback }]
                    : [];
            }

            const hasExplicitDefault = pricings.some((pricing) => (
                Boolean(pricing?.isDefault)
                || (
                    defaultPricingId != null
                    && pricing?.id != null
                    && String(pricing.id) === String(defaultPricingId)
                )
            ));

            const labels = pricings
                .map((pricing, index) => {
                    const code = String(pricing.furnizorCode || '').trim();
                    const name = String(pricing.furnizorName || '').trim();
                    let label = '';
                    if (pricing.usesManufacturerAsFurnizor) {
                        label = manufacturerName || name || code || 'Producător';
                    } else {
                        label = name || code;
                    }
                    if (!label) {
                        return null;
                    }
                    const isDefault = hasExplicitDefault
                        ? (
                            Boolean(pricing.isDefault)
                            || (
                                defaultPricingId != null
                                && pricing?.id != null
                                && String(pricing.id) === String(defaultPricingId)
                            )
                        )
                        : index === 0;
                    return {
                        label,
                        isDefault,
                        searchText: [code, name, manufacturerName, label]
                            .filter(Boolean)
                            .join(' '),
                    };
                })
                .filter(Boolean);

            return labels.sort((a, b) => Number(b.isDefault) - Number(a.isDefault));
        },
        /**
         * @param {Object} item
         * @returns {string}
         */
        getPrimaryFurnizorLabel(item) {
            const labels = this.getItemFurnizorLabels(item);
            if (!labels.length) {
                return '';
            }
            const defaultLabel = labels.find((row) => row.isDefault);
            return (defaultLabel || labels[0]).label;
        },
        /**
         * Default furnizor pricing row from pricing_detail (or first tab).
         * @param {Object|null|undefined} pricingDetail
         * @returns {Object|null}
         */
        getDefaultFurnizorPricingFromDetail(pricingDetail) {
            const detail = pricingDetail || {};
            const pricings = Array.isArray(detail.furnizorPricings)
                ? detail.furnizorPricings
                : [];
            if (!pricings.length) {
                return null;
            }
            const defaultPricingId = detail.defaultFurnizorPricingId;
            return pricings.find((pricing) => Boolean(pricing?.isDefault))
                || (
                    defaultPricingId != null
                        ? pricings.find((pricing) => (
                            pricing?.id != null
                            && String(pricing.id) === String(defaultPricingId)
                        ))
                        : null
                )
                || pricings[0]
                || null;
        },
        /**
         * @param {Object} item
         * @returns {string}
         */
        /**
         * @param {Object} item
         * @param {'lt_ref'|'gt_ref'} op
         * @returns {boolean}
         */
        matchesMarkupActualVsReference(item, op) {
            if (
                item?.markup_actual === null
                || item?.markup_actual === undefined
                || item?.markup_actual === ''
                || item?.markup_reference === null
                || item?.markup_reference === undefined
                || item?.markup_reference === ''
            ) {
                return false;
            }
            const actual = parseNumericInput(item.markup_actual);
            const reference = parseNumericInput(item.markup_reference);
            const threshold = 0.001;
            if (op === 'lt_ref') {
                return actual < reference - threshold;
            }
            return actual > reference + threshold;
        },
        markupActualDiffClass(item) {
            if (
                item?.markup_actual === null
                || item?.markup_actual === undefined
                || item?.markup_actual === ''
                || item?.markup_reference === null
                || item?.markup_reference === undefined
                || item?.markup_reference === ''
            ) {
                return '';
            }
            const actual = parseNumericInput(item.markup_actual);
            const reference = parseNumericInput(item.markup_reference);
            const threshold = 0.001;
            if (actual < reference - threshold) {
                return 'text-error';
            }
            if (actual > reference + threshold) {
                return 'text-info';
            }
            return '';
        },
        /**
         * @param {Object} item
         * @param {string} normalizedSearch
         * @returns {boolean}
         */
        itemMatchesSupplierSearch(item, normalizedSearch) {
            return this.getItemFurnizorLabels(item).some((row) =>
                String(row.searchText || row.label || '')
                    .toLowerCase()
                    .includes(normalizedSearch),
            );
        },
        /**
         * @param {Object} item
         * @param {string} normalizedSearch
         * @returns {boolean}
         */
        itemMatchesSystemSearch(item, normalizedSearch) {
            return getProductMainCategories(item).some((categoryName) => {
                const label = getCategoryLabel(categoryName);
                const shortLabel = getCategoryShortLabel(categoryName);
                return (
                    String(categoryName).toLowerCase().includes(normalizedSearch)
                    || String(label).toLowerCase().includes(normalizedSearch)
                    || String(shortLabel).toLowerCase().includes(normalizedSearch)
                );
            });
        },
        isPriceListProductsCacheValid(cachedProducts) {
            if (
                !cachedProducts ||
                !Array.isArray(cachedProducts.items) ||
                !cachedProducts.items.length
            ) {
                return false;
            }

            if (cachedProducts.type !== this.selectedPriceListType) {
                return false;
            }

            if (
                Number(cachedProducts.price_list_id) !==
                Number(this.selectedPriceList)
            ) {
                return false;
            }

            return cachedProducts.items.some(
                item => item.has_pricing_detail || item.pricing_detail,
            );
        },
        async resetFiltersAndReload() {
            this.suppressProductsFilterWatch = true;
            this.search = '';
            this.clearSystemFilter();
            this.clearFurnizorFilter();
            this.clearStructureFilter();
            this.selectedVisibleInOfferFilter = null;
            this.selectedStatusFilter = null;
            this.clearMarkupActualFilter();
            this.clearMarkupReferenceFilter();
            this.productsPage = 1;
            this.suppressProductsFilterWatch = false;

            await this.initialize();
        },
        buildPriceListItemsQueryParams() {
            const pageSize = Number(this.productsItemsPerPage);
            const params = {
                page: Number(this.productsPage) || 1,
                itemsPerPage: Number.isFinite(pageSize) && pageSize > 0
                    ? Math.min(pageSize, 100)
                    : 50,
            };
            const search = String(this.search || '').trim();
            if (search) {
                params.search = search;
            }
            if (this.selectedStatusFilter) {
                params.status = this.selectedStatusFilter;
            } else {
                params.exclude_status = 'anulat';
            }
            if (this.selectedVisibleInOfferFilter !== null) {
                params.visible_in_offer_app = this.selectedVisibleInOfferFilter;
            }
            if (this.selectedSystemFilter) {
                params.system = this.selectedSystemFilter;
            }
            if (this.selectedFurnizorFilter) {
                params.furnizor = this.selectedFurnizorFilter;
            }
            if (this.selectedChapterFilter) {
                params.chapter_code = this.selectedChapterFilter;
            }
            if (this.selectedSubchapterFilter) {
                const [code] = String(this.selectedSubchapterFilter).split('::');
                const subchapterCode = padSubchapterCode(code);
                if (subchapterCode) {
                    params.subchapter_code = subchapterCode;
                }
            }
            return params;
        },
        async fetchPriceListProductsPage() {
            if (!this.selectedPriceList) {
                this.items = [];
                this.productsTotalCount = 0;
                return;
            }
            const response = await apiClient.get(
                `/api/price_lists/${this.selectedPriceList}/items/`,
                { params: this.buildPriceListItemsQueryParams() },
            );
            this.expandedMultiFurnizorProductIds = {};
            this.items = this.mapProductItems(response.data.items || []);
            this.productsTotalCount = Number(response.data.count) || 0;
            if (response.data.page) {
                this.productsPage = Number(response.data.page) || this.productsPage;
            }
        },
        scheduleProductsReload({ resetPage = false } = {}) {
            if (this.productsFilterReloadTimer) {
                clearTimeout(this.productsFilterReloadTimer);
            }
            this.productsFilterReloadTimer = setTimeout(() => {
                this.productsFilterReloadTimer = null;
                if (resetPage) {
                    this.productsPage = 1;
                }
                this.initialize();
            }, 300);
        },
        onProductsPageChange(page) {
            const nextPage = Number(page) || 1;
            if (nextPage === this.productsPage && this.loading) {
                return;
            }
            this.productsPage = nextPage;
            this.initialize();
        },
        onProductsItemsPerPageChange(size) {
            const next = Number(size);
            this.productsItemsPerPage = Number.isFinite(next) && next > 0
                ? Math.min(next, 100)
                : 50;
            this.productsPage = 1;
            this.initialize();
        },
        async initialize() {
            try {
                this.loading = true;
                await this.fetchPriceListProductsPage();
            } catch (error) {
                showAlertModal(
                    this.$store,
                    "A apărut o eroare la preluarea produselor. Vă rugăm reîncărcați pagina.",
                    "danger",
                    12000,
                    error,
                );
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        /**
         * Maps API product rows to display format (measurement unit text, sorted by code).
         *
         * @param {Array<Object>} rawItems
         * @returns {Array<Object>}
         */
        mapProductItems(rawItems) {
            return this.sortProductsByProductCode(
                rawItems.map(item => {
                    const unit = this.measurementUnits.find(
                        u => u.number === item.measurement_unit,
                    );
                    const pricingDetail = item?.pricing_detail || {};
                    const defaultFurnizorPricing = this.getDefaultFurnizorPricingFromDetail(
                        pricingDetail,
                    );
                    const supplierListPriceRaw = defaultFurnizorPricing?.supplierListPriceNew
                        ?? pricingDetail.supplierListPriceNew
                        ?? null;
                    let supplierListPrice = null;
                    if (
                        supplierListPriceRaw !== null
                        && supplierListPriceRaw !== undefined
                        && supplierListPriceRaw !== ''
                    ) {
                        const parsed = parseNumericInput(supplierListPriceRaw);
                        supplierListPrice = Number.isFinite(parsed) ? parsed : null;
                    }
                    const currencyRaw = String(
                        defaultFurnizorPricing?.currency
                            ?? pricingDetail.currency
                            ?? '',
                    ).trim().toLowerCase();
                    const appliedDiscounts = resolveAppliedDiscountsDisplay(
                        defaultFurnizorPricing || pricingDetail,
                    );
                    const transportCostRateRaw = defaultFurnizorPricing?.transportCostRate
                        ?? pricingDetail.transportCostRate
                        ?? null;
                    let transportCostRate = null;
                    if (
                        transportCostRateRaw !== null
                        && transportCostRateRaw !== undefined
                        && transportCostRateRaw !== ''
                    ) {
                        const parsed = parseNumericInput(transportCostRateRaw);
                        transportCostRate = Number.isFinite(parsed) ? parsed : null;
                    }
                    const mapped = {
                        ...item,
                        manufacturer_product_name: pricingDetail.manufacturerProductName || '',
                        serial_number: Boolean(pricingDetail.serialNumber),
                        visible_in_offer_app: Boolean(
                            item.visible_in_offer_app
                                ?? pricingDetail.visibleInOfferApp
                                ?? true,
                        ),
                        status: item.status || null,
                        supplier_list_price: supplierListPrice,
                        has_discounts: appliedDiscounts.hasDiscounts,
                        discount_tooltip: appliedDiscounts.tooltip,
                        transport_cost_rate: transportCostRate,
                        currency: currencyRaw || null,
                        entry_price_ron_inc_vat: pricingDetail.entryPriceRonExVat ?? null,
                        price_adjustment_ratio: pricingDetail.priceAdjustmentRatio ?? null,
                        markup_reference: pricingDetail.markupReference ?? null,
                        markup_actual: pricingDetail.markupActual ?? null,
                        price_ex_vat: pricingDetail.listPriceRonExVat ?? null,
                        manufacturer_product_code: pricingDetail.manufacturerProductCode || '',
                        notes: resolveProductNotes(item),
                        measurement_unit: unit ? unit.text : item.measurement_unit,
                    };
                    mapped.furnizor = this.getPrimaryFurnizorLabel(mapped);
                    return mapped;
                }),
            );
        },
        /**
         * Sorts an array of products by their product code.
         *
         * @param {Array<Object>} products - The array of product objects to sort.
         * @returns {Array<Object>} - The sorted array of products.
         */
        sortProductsByProductCode(products) {
            return products.sort((a, b) => {
                return this.sortByProductCode(a, b, 1);
            });
        },
        syncListPricingSettingsForm() {
            const settings = this.listPricingSettings;
            this.listPricingSettingsForm = {
                exchangeRateEur: String(settings.exchangeRateEur),
                exchangeRatePln: String(settings.exchangeRatePln),
                exchangeRateUsd: String(settings.exchangeRateUsd),
            };
        },
        async saveListPricingSettings() {
            if (!this.selectedPriceList) {
                return;
            }

            this.savingListPricingSettings = true;
            try {
                const response = await apiClient.patch(
                    `/api/price_lists/${this.selectedPriceList}/`,
                    {
                        pricing_settings: {
                            ...this.listPricingSettings,
                            exchangeRateEur: parseNumericInput(
                                this.listPricingSettingsForm.exchangeRateEur,
                            ),
                            exchangeRatePln: parseNumericInput(
                                this.listPricingSettingsForm.exchangeRatePln,
                            ),
                            exchangeRateUsd: parseNumericInput(
                                this.listPricingSettingsForm.exchangeRateUsd,
                            ),
                        },
                    },
                );
                const index = this.priceLists.findIndex(
                    priceList => priceList.id === this.selectedPriceList,
                );
                if (index >= 0) {
                    this.priceLists[index] = {
                        ...this.priceLists[index],
                        pricing_settings: response.data.pricing_settings,
                    };
                }
                this.syncListPricingSettingsForm();
                showAlertModal(
                    this.$store,
                    "Cursurile valutare au fost salvate pentru această listă.",
                    "success",
                    5000,
                );
            } catch (error) {
                console.error("Error saving list pricing settings:", error);
                showAlertModal(
                    this.$store,
                    "A apărut o eroare la salvarea cursurilor valutare.",
                    "danger",
                    8000,
                    error,
                );
            } finally {
                this.savingListPricingSettings = false;
            }
        },
        /**
         * Fetches all available price lists based on the selected type and sorts them.
         * Updates the `priceLists` variable with the fetched data.
         *
         * @async
         */
        async getPriceLists() {
            try {
                // Add the selected price list type as a query parameter in the request
                const response = await apiClient.get("/api/price_lists", {
                    params: {
                        type: this.selectedPriceListType, // Pass the selected price list type
                    },
                });

                // Assign the fetched data to priceLists variable
                this.priceLists = response.data;

                // Sort the priceLists array by id in descending order
                this.priceLists.sort((a, b) => b.id - a.id);

                // Optionally set the current price list to the latest one for the selected type
                this.setCurrentPriceList();
                this.syncListPricingSettingsForm();
            } catch (error) {
                console.error("Error fetching price lists:", error);
                showAlertModal(
                    this.$store,
                    "A apărut o eroare la preluarea listelor de prețuri. Vă rugăm reîncărcați pagina.",
                    "danger",
                    12000,
                    error,
                );
            }
        },
        /**
         * Handles changes in the selected price list type by refetching the price lists.
         *
         * @async
         */
        async onPriceListTypeChange() {
            await this.getPriceLists(); // Refetch the price lists when the type changes
        },
        /**
         * Sets the currently selected price list to the latest applicable one based on its application date.
         * Excludes future price lists and sorts the list by date to find the most recent.
         */
        setCurrentPriceList() {
            let data = this.priceLists; // your array data
            let today = new Date();

            // 1. Filter out future dates
            data = data.filter(item => {
                // Convert the date string to a Date object
                let itemDate = new Date(item.date_applied + "T00:00:00");
                return itemDate <= today;
            });

            // 2. Sort the array by date in descending order
            data.sort((a, b) => {
                // Convert the date strings to Date objects
                let dateA = new Date(a.date_applied + "T00:00:00");
                let dateB = new Date(b.date_applied + "T00:00:00");
                return dateB - dateA;
            });

            // 3. The first item now has the closest date_applied (not in the future)
            this.selectedPriceList = data.length > 0 ? data[0].id : null;
        },
        /**
         * Fetches the products for the currently selected price list and updates the items displayed in the table.
         *
         * @async
         */
        async getPriceListProducts() {
            this.suppressProductsFilterWatch = true;
            this.selectedChapterFilter = null;
            this.selectedSubchapterFilter = null;
            this.selectedVisibleInOfferFilter = null;
            this.selectedStatusFilter = null;
            this.clearMarkupActualFilter();
            this.clearMarkupReferenceFilter();
            this.structureFilterMenuOpen = false;
            this.productsPage = 1;
            this.suppressProductsFilterWatch = false;
            await this.initialize();
        },
        canEditPriceListItem(item) {
            if (!this.canUsePriceListEditor) {
                return false;
            }
            if (!this.isPriceListVerifier) {
                return true;
            }
            const sourceItem = resolveSourceProductItem(item);
            const productCode = String(sourceItem?.product_code || '').trim();
            if (!productCode) {
                return true;
            }
            const liveItem = this.items.find(
                (entry) => entry.product_code === productCode,
            );
            if (!liveItem) {
                return true;
            }
            return normalizeProductStatus(liveItem.status) === 'de_verificat';
        },
        editItem(item) {
            if (!this.canEditPriceListItem(item)) {
                showAlertModal(
                    this.$store,
                    'Puteți modifica doar produse cu status De verificat.',
                    'warning',
                    6000,
                );
                return;
            }
            const sourceItem = resolveSourceProductItem(item);
            const tabKey = item?.furnizorTabKey
                ? String(item.furnizorTabKey)
                : null;
            this.openBuilderForItem(sourceItem, tabKey);
        },
        getSerialNumberChecked(item) {
            const source = resolveSourceProductItem(item);
            return Boolean(source?.serial_number ?? item?.serial_number);
        },
        isSerialNumberSaving(item) {
            const source = resolveSourceProductItem(item);
            return Boolean(source?._serialNumberSaving);
        },
        getVisibleInOfferChecked(item) {
            const source = resolveSourceProductItem(item);
            return Boolean(
                source?.visible_in_offer_app ?? item?.visible_in_offer_app,
            );
        },
        isVisibleInOfferSaving(item) {
            const source = resolveSourceProductItem(item);
            return Boolean(source?._visibleInOfferSaving);
        },
        async onSerialNumberToggle(item, checked) {
            const target = resolveSourceProductItem(item);
            if (!target?.id || item?.is_multi_furnizor_child) {
                return;
            }
            const previous = Boolean(target.serial_number);
            const nextValue = Boolean(checked);
            if (previous === nextValue) {
                return;
            }

            target.serial_number = nextValue;
            if (target.pricing_detail && typeof target.pricing_detail === "object") {
                target.pricing_detail = {
                    ...target.pricing_detail,
                    serialNumber: nextValue,
                };
            }
            target._serialNumberSaving = true;

            try {
                await apiClient.patch(`/api/items/${target.id}/`, {
                    serialNumber: nextValue,
                });
            } catch (error) {
                target.serial_number = previous;
                if (target.pricing_detail && typeof target.pricing_detail === "object") {
                    target.pricing_detail = {
                        ...target.pricing_detail,
                        serialNumber: previous,
                    };
                }
                showAlertModal(
                    this.$store,
                    "Nu s-a putut actualiza Serial nr. Încercați din nou.",
                    "danger",
                    8000,
                    error,
                );
            } finally {
                target._serialNumberSaving = false;
            }
        },
        onVisibleInOfferToggleRequest(item, checked) {
            const target = resolveSourceProductItem(item);
            if (!target?.id || target._visibleInOfferSaving || item?.is_multi_furnizor_child) {
                return;
            }
            const previous = Boolean(target.visible_in_offer_app);
            const nextValue = Boolean(checked);
            if (previous === nextValue) {
                return;
            }
            this.visibilityConfirmItem = target;
            this.visibilityConfirmNextValue = nextValue;
            this.dialogVisibleInOfferConfirm = true;
        },
        closeVisibleInOfferConfirm() {
            this.dialogVisibleInOfferConfirm = false;
            this.visibilityConfirmItem = null;
            this.visibilityConfirmNextValue = null;
        },
        async confirmVisibleInOfferToggle() {
            const item = this.visibilityConfirmItem;
            const nextValue = Boolean(this.visibilityConfirmNextValue);
            if (!item?.id) {
                this.closeVisibleInOfferConfirm();
                return;
            }
            const previous = Boolean(item.visible_in_offer_app);
            if (previous === nextValue) {
                this.closeVisibleInOfferConfirm();
                return;
            }

            item.visible_in_offer_app = nextValue;
            item._visibleInOfferSaving = true;

            try {
                await apiClient.patch(`/api/items/${item.id}/`, {
                    visibleInOfferApp: nextValue,
                });
                this.syncVisibleInOfferCache(item.id, nextValue);
                this.closeVisibleInOfferConfirm();
            } catch (error) {
                item.visible_in_offer_app = previous;
                showAlertModal(
                    this.$store,
                    "Nu s-a putut actualiza vizibilitatea în programul de ofertare. Încercați din nou.",
                    "danger",
                    8000,
                    error,
                );
            } finally {
                item._visibleInOfferSaving = false;
            }
        },
        syncVisibleInOfferCache(itemId, nextValue) {
            try {
                const cachedRaw = sessionStorage.getItem("PRICE_LIST_PRODUCTS");
                if (!cachedRaw) {
                    return;
                }
                const cached = JSON.parse(cachedRaw);
                if (!Array.isArray(cached?.items)) {
                    return;
                }
                const index = cached.items.findIndex(
                    (row) => Number(row?.id) === Number(itemId),
                );
                if (index < 0) {
                    return;
                }
                cached.items[index] = {
                    ...cached.items[index],
                    visible_in_offer_app: nextValue,
                };
                sessionStorage.setItem(
                    "PRICE_LIST_PRODUCTS",
                    JSON.stringify(cached),
                );
            } catch (cacheError) {
                console.error(
                    "Failed to sync visible_in_offer_app cache:",
                    cacheError,
                );
            }
        },
        openBulkPropertyDialog() {
            this.bulkPropertyDialogOpen = true;
        },
        async onBulkPropertyDrafts(drafts) {
            this.bulkPropertySaving = true;
            try {
                await this.onAddSimpleDrafts(drafts);
                this.bulkPropertyDialogOpen = false;
            } finally {
                this.bulkPropertySaving = false;
            }
        },
        async onBulkPropertyDirect(payloads) {
            this.bulkPropertyApplying = true;
            try {
                await this.onApplyDirectUpdates(payloads);
                this.bulkPropertyDialogOpen = false;
            } finally {
                this.bulkPropertyApplying = false;
            }
        },
        openBuilderForItem(rowOrItem, furnizorTabKey = null) {
            const sourceItem = resolveSourceProductItem(rowOrItem);
            const tabKey = furnizorTabKey
                ? String(furnizorTabKey)
                : (
                    rowOrItem?.furnizorTabKey
                        ? String(rowOrItem.furnizorTabKey)
                        : null
                );

            const draft = findDraftByProductCode(
                this.productDrafts,
                sourceItem?.product_code,
            );
            if (draft?.updateMode === "builder" || draft?.builderState) {
                this.clearBuilderContext();
                this.builderInitialFurnizorTabKey = tabKey;
                this.builderDraftEntry = draft;
                this.builderDialog = true;
                return;
            }

            this.clearBuilderContext();

            let resolvedItem = sourceItem;

            const pendingUpdate = resolvePendingUpdateFromRow(rowOrItem, draft);
            if (pendingUpdate) {
                resolvedItem = applyPendingListPriceToItem(
                    resolvedItem,
                    pendingUpdate.price,
                    { productName: pendingUpdate.productName },
                );
            }

            this.builderEditItem = {
                ...resolvedItem,
                categories: [...getProductMainCategories(resolvedItem)],
            };
            this.builderInitialFurnizorTabKey = tabKey;
            this.builderDialog = true;
        },
        clearBuilderContext() {
            this.builderEditItem = null;
            this.builderDraftEntry = null;
            this.builderReadOnly = false;
            this.builderCompareChanges = [];
            this.builderCompareFurnizorTabKey = null;
            this.builderCompareReferencePayload = null;
            this.builderInitialFurnizorTabKey = null;
        },
        openBuilderDialog() {
            this.clearBuilderContext();
            this.builderDialog = true;
        },
        onCompareViewProduct({
            editItem,
            changes = [],
            furnizorTabKey = null,
            referencePayload = null,
        }) {
            if (!editItem) {
                return;
            }
            this.clearBuilderContext();
            this.builderEditItem = {
                ...editItem,
                categories: [...(editItem.categories || [])],
            };
            this.builderReadOnly = true;
            this.builderCompareChanges = Array.isArray(changes) ? changes : [];
            this.builderCompareFurnizorTabKey = furnizorTabKey
                ? String(furnizorTabKey)
                : null;
            this.builderCompareReferencePayload = referencePayload || null;
            this.builderDialog = true;
        },
        canMutatePriceListDraft(draft) {
            if (!this.isPriceListVerifier) {
                return true;
            }
            if (!draft) {
                return false;
            }
            const payloadStatus = normalizeProductStatus(
                draft?.payload?.status
                ?? draft?.builderState?.productBuilderForm?.status,
            );
            if (payloadStatus === 'de_verificat') {
                return true;
            }
            // Legacy / simple drafts may omit status in payload — fall back to live product.
            if (payloadStatus == null) {
                const sourceCode = String(
                    draft.payload?.product_code
                    || draft.product_code
                    || '',
                ).trim();
                const liveItem = this.items.find(
                    (item) => item.product_code === sourceCode,
                );
                return normalizeProductStatus(liveItem?.status) === 'de_verificat';
            }
            return false;
        },
        editProductDraft(draft, furnizorTabKey = null) {
            if (!this.canMutatePriceListDraft(draft)) {
                showAlertModal(
                    this.$store,
                    'Puteți modifica doar produse cu status De verificat.',
                    'warning',
                    6000,
                );
                return;
            }
            const tabKey = furnizorTabKey ? String(furnizorTabKey) : null;
            if (draft.updateMode === "builder" || draft.builderState) {
                this.clearBuilderContext();
                this.builderInitialFurnizorTabKey = tabKey;
                this.builderDraftEntry = draft;
                this.builderDialog = true;
                return;
            }
            const productCode = draft.payload?.product_code || "";
            const sourceItem = this.items.find(
                (item) => item.product_code === productCode,
            ) || { product_code: productCode, ...(draft.payload || {}) };
            this.openBuilderForItem(sourceItem, tabKey);
        },
        async onDraftSetDefaultFurnizor({ draft, furnizorTabKey }) {
            if (!this.canMutatePriceListDraft(draft)) {
                showAlertModal(
                    this.$store,
                    'Puteți modifica doar produse cu status De verificat.',
                    'warning',
                    6000,
                );
                return;
            }
            const updated = applyDraftDefaultFurnizor(draft, furnizorTabKey);
            if (!updated) {
                showAlertModal(
                    this.$store,
                    "Nu s-a putut schimba produsul implicit pentru acest draft.",
                    "warning",
                    6000,
                );
                return;
            }
            try {
                await saveDraftEntry({
                    priceListType: this.selectedPriceListType,
                    priceListId: this.selectedPriceList,
                    entry: updated,
                });
                await this.loadProductDrafts();
                showAlertModal(
                    this.$store,
                    "Produsul implicit a fost actualizat în lista în lucru.",
                    "success",
                    5000,
                );
            } catch (error) {
                showAlertModal(
                    this.$store,
                    "A apărut o eroare la actualizarea produsului implicit.",
                    "danger",
                    12000,
                    error,
                );
            }
        },
        async loadProductDrafts() {
            if (!this.canUsePriceListEditor) {
                this.productDrafts = [];
                return;
            }
            this.productDrafts = await fetchDraftQueue(
                this.selectedPriceListType,
                this.selectedPriceList,
            );
        },
        async onBuilderDraftSave({
            payload,
            builderState,
            replaceDraftId,
            sourceProductCode,
            propagate = null,
        }) {
            this.builderSavingDraft = true;
            try {
                if (this.isPriceListVerifier) {
                    payload = {
                        ...payload,
                        status: 'de_verificat',
                    };
                    const existingCodes = this.items.map(item => item.product_code);
                    const draftAction = resolveDraftAction(payload, existingCodes);
                    const sourceCode = sourceProductCode
                        || payload.old_product_code
                        || payload.product_code;
                    const existingItem = this.items.find(
                        item => item.product_code === sourceCode,
                    );
                    if (
                        draftAction === 'update'
                        && existingItem
                        && normalizeProductStatus(existingItem.status) !== 'de_verificat'
                    ) {
                        showAlertModal(
                            this.$store,
                            'Puteți modifica doar produse cu status De verificat.',
                            'warning',
                            6000,
                        );
                        return;
                    }
                }
                const existingCodes = this.items.map(item => item.product_code);
                const action = resolveDraftAction(payload, existingCodes);
                const sourceCode =
                    sourceProductCode
                    || payload.old_product_code
                    || payload.product_code;
                const existingItem = this.items.find(
                    item => item.product_code === sourceCode,
                );
                const entry = createDraftEntry({
                    action,
                    payload,
                    builderState,
                    sourceProductCode:
                        sourceProductCode || payload.old_product_code || null,
                    previousPrice:
                        action === "update"
                            ? existingItem?.price ?? null
                            : null,
                    updateMode: "builder",
                });
                if (replaceDraftId) {
                    entry.id = replaceDraftId;
                }
                await saveDraftEntry({
                    priceListType: this.selectedPriceListType,
                    priceListId: this.selectedPriceList,
                    entry,
                });

                let propagateCount = 0;
                let propagateSkipped = 0;
                if (
                    propagate
                    && Array.isArray(propagate.fieldKeys)
                    && propagate.fieldKeys.length
                    && Array.isArray(propagate.targetProductCodes)
                    && propagate.targetProductCodes.length
                    && propagate.identity
                ) {
                    const peerItems = propagate.targetProductCodes
                        .map((code) => resolvePropagatePeerItem({
                            productCode: code,
                            items: this.items,
                            drafts: this.productDrafts,
                        }))
                        .filter(Boolean);
                    const priceListIds = Array.isArray(payload.price_list_ids)
                        ? payload.price_list_ids
                        : (this.selectedPriceList != null
                            ? [{ id: this.selectedPriceList }]
                            : []);
                    const { drafts, skipped } = buildPropagateDrafts({
                        peerItems,
                        identity: propagate.identity,
                        fieldKeys: propagate.fieldKeys,
                        values: propagate.values || {},
                        existingItems: this.items,
                        priceListIds,
                        pricingSettings: this.listPricingSettings,
                    });
                    propagateSkipped = skipped.length;
                    for (const peerDraft of drafts) {
                        try {
                            await saveDraftEntry({
                                priceListType: this.selectedPriceListType,
                                priceListId: this.selectedPriceList,
                                entry: peerDraft,
                            });
                            propagateCount += 1;
                        } catch (peerError) {
                            console.error(
                                "Failed to save propagate draft:",
                                peerError,
                            );
                            propagateSkipped += 1;
                        }
                    }
                }

                await this.loadProductDrafts();
                this.builderDialog = false;
                let message = action === "update"
                    ? "Actualizarea a fost salvată în lucru. Lista live nu este încă modificată."
                    : "Produsul a fost salvat în lucru. Puteți continua cu alte produse.";
                if (propagateCount > 0) {
                    message += ` Câmpurile selectate au fost aplicate la ${propagateCount} ${
                        propagateCount === 1 ? "produs" : "produse"
                    } în lista în lucru.`;
                }
                if (propagateSkipped > 0) {
                    message += ` ${propagateSkipped} ${
                        propagateSkipped === 1 ? "produs a fost omis" : "produse au fost omise"
                    }.`;
                }
                showAlertModal(
                    this.$store,
                    message,
                    propagateSkipped && !propagateCount ? "warning" : "success",
                    10000,
                );
            } catch (error) {
                showAlertModal(
                    this.$store,
                    "A apărut o eroare la salvarea în lucru. Vă rugăm încercați din nou.",
                    "danger",
                    12000,
                    error,
                );
            } finally {
                this.builderSavingDraft = false;
            }
        },
        async onBuilderSaveDirect({ payload, replaceDraftId }) {
            if (!payload) {
                return;
            }

            this.builderSavingDirect = true;
            try {
                const priceListIds = Array.isArray(payload.price_list_ids)
                    ? [...payload.price_list_ids]
                    : [];
                const hasSelectedList =
                    this.selectedPriceList != null &&
                    this.selectedPriceList !== "" &&
                    priceListIds.some(
                        entry =>
                            (entry?.id ?? entry) === this.selectedPriceList,
                    );
                if (!hasSelectedList && this.selectedPriceList != null) {
                    priceListIds.push({ id: this.selectedPriceList });
                }
                if (!priceListIds.length) {
                    showAlertModal(
                        this.$store,
                        "Selectați o listă de prețuri înainte de a salva produsul.",
                        "warning",
                        8000,
                    );
                    return;
                }

                const removalCodes = Array.isArray(
                    payload.compositeComponentRemovalCodes,
                )
                    ? [...payload.compositeComponentRemovalCodes]
                    : [];
                const savePayload = {
                    ...payload,
                    price_list_ids: priceListIds,
                };
                delete savePayload.compositeComponentRemovalCodes;

                const response = await this.createProduct(savePayload);
                if (response?.status !== 201) {
                    showAlertModal(
                        this.$store,
                        "Salvarea produsului în listă a eșuat.",
                        "danger",
                        10000,
                    );
                    return;
                }

                if (removalCodes.length) {
                    await this.removeComponentsFromPriceList(
                        removalCodes,
                        this.selectedPriceList,
                    );
                }

                if (replaceDraftId) {
                    try {
                        await deleteDraftEntry(replaceDraftId);
                        await this.loadProductDrafts();
                    } catch (error) {
                        console.error(
                            "Failed to remove draft after direct save:",
                            error,
                        );
                    }
                }

                await this.handleProductSaved(response, savePayload);
                this.builderDialog = false;
                showAlertModal(
                    this.$store,
                    `Produsul ${savePayload.product_code} a fost salvat în listă.`,
                    "success",
                    8000,
                );
            } catch (error) {
                // createProduct already shows an alert unless silent.
                console.error("onBuilderSaveDirect error:", error);
            } finally {
                this.builderSavingDirect = false;
            }
        },
        async onAddSimpleDraft(draft) {
            await this.onAddSimpleDrafts([draft]);
        },
        async onAddSimpleDrafts(drafts) {
            if (!drafts?.length) {
                return;
            }
            this.draftSaving = true;
            let successCount = 0;
            const failedCodes = [];

            try {
                for (const draft of drafts) {
                    const productCode = String(
                        draft.payload?.product_code || "",
                    ).trim();
                    try {
                        await saveDraftEntry({
                            priceListType: this.selectedPriceListType,
                            priceListId: this.selectedPriceList,
                            entry: draft,
                        });
                        successCount += 1;
                    } catch (error) {
                        failedCodes.push(productCode || "necunoscut");
                        console.error("Failed to save draft:", error);
                    }
                }

                await this.loadProductDrafts();

                if (!failedCodes.length) {
                    showAlertModal(
                        this.$store,
                        successCount === 1
                            ? `Modificarea pentru ${drafts[0].payload?.product_code} a fost salvată în lucru.`
                            : `${successCount} modificări au fost salvate în lucru.`,
                        "success",
                        6000,
                    );
                } else {
                    showAlertModal(
                        this.$store,
                        `Salvate în lucru: ${successCount}. Eșuate: ${
                            failedCodes.length
                        } (${failedCodes.join(", ")}).`,
                        successCount ? "warning" : "danger",
                        10000,
                    );
                }
            } finally {
                this.draftSaving = false;
            }
        },
        async onApplyDirectUpdates(payloads) {
            if (!payloads?.length) {
                return;
            }
            this.directApplying = true;
            let successCount = 0;
            const failedCodes = [];

            try {
                for (const payload of payloads) {
                    const productCode = String(
                        payload?.product_code || "",
                    ).trim();
                    try {
                        const response = await this.createProduct(payload, {
                            silent: true,
                        });
                        if (response?.status === 201) {
                            successCount += 1;
                            await this.handleProductSaved(response, payload, {
                                refreshList: false,
                                refreshHistory: false,
                            });
                        } else {
                            failedCodes.push(productCode || "necunoscut");
                        }
                    } catch (error) {
                        failedCodes.push(productCode || "necunoscut");
                        console.error("Failed to apply direct update:", error);
                    }
                }

                if (successCount) {
                    await this.getPriceListProducts();
                    this.refreshPriceListHistory();
                }

                if (!failedCodes.length) {
                    showAlertModal(
                        this.$store,
                        successCount === 1
                            ? `Produsul ${payloads[0].product_code} a fost actualizat în listă.`
                            : `${successCount} produse au fost actualizate în listă.`,
                        "success",
                        8000,
                    );
                } else {
                    showAlertModal(
                        this.$store,
                        `Actualizate: ${successCount}. Eșuate: ${
                            failedCodes.length
                        } (${failedCodes.join(", ")}).`,
                        successCount ? "warning" : "danger",
                        12000,
                    );
                }
            } finally {
                this.directApplying = false;
            }
        },
        async removeProductDraft(draft) {
            if (!this.canMutatePriceListDraft(draft)) {
                showAlertModal(
                    this.$store,
                    'Puteți șterge din lista în lucru doar produse cu status De verificat.',
                    'warning',
                    6000,
                );
                return;
            }
            try {
                await deleteDraftEntry(draft.id);
                await this.loadProductDrafts();
            } catch (error) {
                showAlertModal(
                    this.$store,
                    "A apărut o eroare la ștergerea din lista în lucru. Vă rugăm încercați din nou.",
                    "danger",
                    12000,
                    error,
                );
            }
        },
        async clearProductDrafts() {
            if (!this.canManagePriceList) {
                showAlertModal(
                    this.$store,
                    'Nu aveți dreptul să goliți lista în lucru.',
                    'warning',
                    6000,
                );
                return;
            }
            try {
                await clearDraftQueue(
                    this.selectedPriceListType,
                    this.selectedPriceList,
                );
                await this.loadProductDrafts();
            } catch (error) {
                showAlertModal(
                    this.$store,
                    "A apărut o eroare la golirea listei în lucru. Vă rugăm încercați din nou.",
                    "danger",
                    12000,
                    error,
                );
            }
        },
        async publishProductDrafts({ priceListId, createdNewList = false } = {}) {
            const selectedIds = new Set(
                (this.draftIdsToPublish || []).map((id) => String(id)),
            );
            const draftsToPublish = selectedIds.size
                ? this.productDrafts.filter((draft) => (
                    selectedIds.has(String(draft.id))
                ))
                : [...this.productDrafts];
            if (!draftsToPublish.length) {
                return;
            }
            if (!priceListId) {
                return;
            }

            this.publishingDrafts = true;
            const successfulDraftIds = [];
            const failedDrafts = [];
            const previousPriceListId = this.selectedPriceList;
            const remainingCount = this.productDrafts.length - draftsToPublish.length;

            try {
                for (const draft of draftsToPublish) {
                    try {
                        const removalCodes = Array.isArray(
                            draft.payload?.compositeComponentRemovalCodes,
                        )
                            ? [...draft.payload.compositeComponentRemovalCodes]
                            : [];
                        const payload = {
                            ...draft.payload,
                            price_list_ids: [{ id: priceListId }],
                        };
                        delete payload.compositeComponentRemovalCodes;
                        const response = await this.createProduct(payload, {
                            silent: true,
                        });
                        if (response?.status === 201) {
                            successfulDraftIds.push(draft.id);
                            if (removalCodes.length) {
                                await this.removeComponentsFromPriceList(
                                    removalCodes,
                                    priceListId,
                                );
                            }
                            await this.handleProductSaved(response, payload, {
                                refreshList: false,
                                refreshHistory: false,
                            });
                        } else {
                            failedDrafts.push({
                                draft,
                                message: "Salvarea produsului a eșuat.",
                            });
                        }
                    } catch (error) {
                        failedDrafts.push({
                            draft,
                            message:
                                error?.response?.data?.error ||
                                error?.response?.data?.errors?.join?.(" ") ||
                                draft.summary?.product_code,
                        });
                    }
                }

                if (successfulDraftIds.length) {
                    for (const draft of draftsToPublish) {
                        if (!successfulDraftIds.some(
                            (id) => String(id) === String(draft.id),
                        )) {
                            continue;
                        }
                        try {
                            const persistedId = await resolvePersistedDraftId(
                                draft,
                                this.selectedPriceListType,
                                previousPriceListId,
                            );
                            if (persistedId != null) {
                                await deleteDraftEntry(persistedId);
                            }
                        } catch (error) {
                            console.error(
                                "Failed to remove published draft:",
                                error,
                            );
                        }
                    }

                    const successfulIdSet = new Set(
                        successfulDraftIds.map((id) => String(id)),
                    );
                    const remainingDrafts = this.productDrafts.filter(
                        (draft) => !successfulIdSet.has(String(draft.id)),
                    );
                    const targetListChanged = String(previousPriceListId ?? "")
                        !== String(priceListId ?? "");
                    if (remainingDrafts.length && targetListChanged) {
                        for (const draft of remainingDrafts) {
                            try {
                                await migrateDraftEntry({
                                    priceListType: this.selectedPriceListType,
                                    fromPriceListId: previousPriceListId,
                                    toPriceListId: priceListId,
                                    entry: draft,
                                });
                            } catch (error) {
                                console.error(
                                    "Failed to migrate remaining draft:",
                                    error,
                                );
                            }
                        }
                    }

                    this.selectedPriceList = priceListId;
                    await this.getPriceLists();
                    await this.getPriceListProducts();
                    await this.loadProductDrafts();
                    this.refreshPriceListHistory();
                    this.publishDraftsDialog = false;
                    this.draftIdsToPublish = [];
                }

                if (successfulDraftIds.length) {
                    const publishedDrafts = draftsToPublish.filter((draft) => (
                        successfulDraftIds.some(
                            (id) => String(id) === String(draft.id),
                        )
                    ));
                    const notificationChanges = extractPriceListNotificationChanges(
                        publishedDrafts,
                    );
                    if (notificationChanges.length) {
                        try {
                            await notifyPriceListChanges({
                                priceListId,
                                isNewList: createdNewList,
                                changes: notificationChanges,
                                // Set to false when ready to notify all agents in production.
                                test: false,
                            });
                        } catch (error) {
                            console.error(
                                "Failed to send price list notification:",
                                error,
                            );
                            showAlertModal(
                                this.$store,
                                "Lista a fost actualizată, dar emailul de notificare nu a putut fi trimis.",
                                "warning",
                                10000,
                                error,
                            );
                        }
                    }
                }

                if (!failedDrafts.length) {
                    const keptNote = remainingCount > 0
                        ? ` ${remainingCount} produs(e) rămân în lista în lucru.`
                        : " Celelalte produse din listă nu au fost afectate.";
                    showAlertModal(
                        this.$store,
                        `${successfulDraftIds.length} produs(e) au fost aplicate în listă.${keptNote}`,
                        "success",
                        10000,
                    );
                } else {
                    const failedCodes = failedDrafts
                        .map(entry => entry.draft.summary?.product_code)
                        .filter(Boolean)
                        .join(", ");
                    showAlertModal(
                        this.$store,
                        `Aplicate: ${successfulDraftIds.length}. Eșuate: ${
                            failedDrafts.length
                        }${failedCodes ? ` (${failedCodes})` : ""}.`,
                        successfulDraftIds.length ? "warning" : "danger",
                        12000,
                    );
                }
            } finally {
                this.publishingDrafts = false;
            }
        },
        openPublishDraftsDialog(draftIds = null) {
            if (!this.productDrafts.length) {
                return;
            }
            const ids = Array.isArray(draftIds) && draftIds.length
                ? draftIds
                : this.productDrafts.map((draft) => draft.id);
            if (!ids.length) {
                return;
            }
            this.draftIdsToPublish = [...ids];
            this.publishDraftsDialog = true;
        },
        openCompareDialog() {
            this.compareDialog = true;
        },
        openSupplierCompare(item) {
            const source = resolveSourceProductItem(item);
            if (!this.canManagePriceList || !source?.product_code) {
                return;
            }
            const code = String(source.product_code).trim();
            this.supplierCompareProductCodes = [code];
            this.supplierCompareReferenceCode = code;
            this.supplierCompareDialog = true;
        },
        /**
         * Fetches the price lists that the selected item is part of from the API.
         * Groups the price lists by type and assigns them to the `groupedPriceLists` object.
         * Updates the `price_list_ids` property of `editedItem` with the grouped price lists.
         *
         * @param {Object} item - The item object, containing the `id` property used to fetch the associated price lists.
         * @returns {Promise<void>} - Populates `groupedPriceLists` and updates `editedItem.price_list_ids` with the fetched price lists.
         */
        getItemPriceLists(item) {
            return apiClient
                .get(`/api/items/${item.id}/price-lists/`)
                .then(response => {
                    const priceLists = response.data.price_lists;

                    // Group price lists by type
                    this.groupedPriceLists = this.groupByType(priceLists);
                    this.editedItem.price_list_ids = JSON.parse(
                        JSON.stringify(this.groupedPriceLists),
                    );
                })
                .catch(error => {
                    console.error("Error fetching price lists:", error);
                    this.editedItem.price_list_ids = {};
                });
        },
        /**
         * Groups an array of price lists by their type. Each type of price list will have its own array of price lists.
         *
         * @param {Array<Object>} priceLists - The array of price list objects to be grouped.
         * @param {string} priceLists[].type - The type of the price list (e.g., 'general', 'services', 'photovoltaics').
         * @returns {Object} - An object where each key is a price list type, and the value is an array of price lists of that type.
         */
        groupByType(priceLists) {
            return priceLists.reduce((groups, priceList) => {
                const type = priceList.type || "General"; // Use the type, or default to 'General'
                if (!groups[type]) {
                    groups[type] = [];
                }
                groups[type].push(priceList);
                return groups;
            }, {});
        },
        isAnulatStatus(value) {
            return String(value || '').trim() === 'anulat';
        },
        /**
         * Prepares to delete an item — first offers moving to status Anulat.
         *
         * @param {Object} item
         */
        async deleteItem(item) {
            const source = resolveSourceProductItem(item);
            if (!source?.id || item?.is_multi_furnizor_child) {
                return;
            }
            this.editedItem = Object.assign({}, source);
            // Already cancelled: skip the choice and go straight to list removal.
            if (this.isAnulatStatus(source.status)) {
                await this.runWithCalculationRequiredGuard('delete', () => {
                    this.proceedToDeleteFromLists();
                });
                return;
            }
            this.dialogDeleteChoice = true;
        },
        async requestDeleteFromLists() {
            await this.runWithCalculationRequiredGuard('delete', () => {
                this.proceedToDeleteFromLists();
            });
        },
        async requestMarkAsAnulat() {
            await this.runWithCalculationRequiredGuard('anulat', () => {
                this.markEditedItemAsAnulat();
            });
        },
        async runWithCalculationRequiredGuard(action, onConfirmed) {
            const productCode = this.editedItem?.product_code;
            try {
                const info = await findCalculationRequiredProduct(productCode);
                if (info) {
                    this.calculationRequiredInfo = info;
                    this.pendingCalculationAction = action;
                    this.dialogDeleteChoice = false;
                    this.dialogCalculationRequiredConfirm = true;
                    return;
                }
            } catch (error) {
                console.error(
                    "Error checking calculation-required product:",
                    error,
                );
            }
            await onConfirmed();
        },
        closeCalculationRequiredConfirm() {
            this.dialogCalculationRequiredConfirm = false;
            this.calculationRequiredInfo = null;
            this.pendingCalculationAction = null;
            // Return to the first delete choice if we still have an edited item.
            if (this.editedItem?.id && !this.isAnulatStatus(this.editedItem.status)) {
                this.dialogDeleteChoice = true;
            } else {
                this.closeDelete();
            }
        },
        async confirmCalculationRequiredAction() {
            const action = this.pendingCalculationAction;
            this.deferDeleteItemReset = true;
            this.dialogCalculationRequiredConfirm = false;
            this.pendingCalculationAction = null;
            this.calculationRequiredInfo = null;
            try {
                if (action === 'anulat') {
                    await this.markEditedItemAsAnulat();
                    return;
                }
                if (action === 'delete') {
                    await this.proceedToDeleteFromLists();
                }
            } finally {
                this.deferDeleteItemReset = false;
            }
        },
        async proceedToDeleteFromLists() {
            const item = this.editedItem;
            this.deferDeleteItemReset = true;
            this.dialogDeleteChoice = false;
            try {
                await this.getItemPriceLists(item);
                this.editedItem = item;
                this.deleteConfirmText = '';
                this.dialogDelete = true;
            } catch (error) {
                console.error("Error opening delete dialog:", error);
            } finally {
                this.deferDeleteItemReset = false;
            }
        },
        async markEditedItemAsAnulat() {
            const item = this.editedItem;
            if (!item?.id || this.markingAsAnulat) {
                return;
            }
            this.markingAsAnulat = true;
            try {
                await apiClient.patch(`/api/items/${item.id}/`, {
                    status: 'anulat',
                });
                const target = this.items.find(
                    (row) => Number(row?.id) === Number(item.id),
                );
                if (target) {
                    target.status = 'anulat';
                }
                this.syncAnulatStatusCache(item.id);
                this.closeDelete();
                await this.initialize();
                showAlertModal(
                    this.$store,
                    "Produs mutat în Anulat.",
                    "success",
                    6000,
                );
            } catch (error) {
                showAlertModal(
                    this.$store,
                    "Nu s-a putut muta în Anulat.",
                    "danger",
                    8000,
                    error,
                );
            } finally {
                this.markingAsAnulat = false;
            }
        },
        syncAnulatStatusCache(itemId) {
            try {
                const cachedRaw = sessionStorage.getItem("PRICE_LIST_PRODUCTS");
                if (!cachedRaw) {
                    return;
                }
                const cached = JSON.parse(cachedRaw);
                if (!Array.isArray(cached?.items)) {
                    return;
                }
                // Remove cancelled products from oferare cache so they cannot be picked.
                cached.items = cached.items.filter(
                    (row) => Number(row?.id) !== Number(itemId),
                );
                sessionStorage.setItem(
                    "PRICE_LIST_PRODUCTS",
                    JSON.stringify(cached),
                );
            } catch (cacheError) {
                console.error("Failed to sync anulat status cache:", cacheError);
            }
        },
        /**
         * Confirms the deletion of a product from selected price lists.
         * Sends the delete request to the server and removes the product from the UI if successful.
         */
        deleteItemConfirm() {
            if (!this.canConfirmDelete) {
                return;
            }
            this.loading = true;
            let product_code = this.editedItem.product_code;

            // Flatten the price_list_ids object (grouped by type) into a single array of IDs
            let price_list_ids = Object.values(this.editedItem.price_list_ids)
                .flat() // Flatten the arrays of price lists
                .map(price_list_id =>
                    price_list_id.id ? price_list_id.id : price_list_id,
                ); // Map to get IDs

            apiClient({
                method: "delete",
                url: "/api/remove_product_from_price_list/",
                data: {
                    product_code: product_code,
                    price_list_ids: price_list_ids,
                },
            })
                .then(async (response) => {
                    if (response.status === 204) {
                        this.refreshPriceListHistory();
                        await this.initialize();
                    }
                    this.closeDelete();
                })
                .catch(error => {
                    console.error("An error occurred:", error);
                })
                .finally(() => {
                    this.dialogDelete = false;
                    this.dialogDeleteChoice = false;
                    this.loading = false;
                });
        },
        /**
         * Closes the delete confirmation dialog and resets the edited item.
         */
        closeDelete() {
            this.dialogDelete = false;
            this.dialogDeleteChoice = false;
            this.dialogCalculationRequiredConfirm = false;
            this.calculationRequiredInfo = null;
            this.pendingCalculationAction = null;
            this.deleteConfirmText = '';
            this.resetEditedItemIfDeleteDialogsClosed();
        },
        resetEditedItemIfDeleteDialogsClosed() {
            setTimeout(() => {
                if (this.deferDeleteItemReset) {
                    return;
                }
                if (
                    !this.dialogDelete
                    && !this.dialogDeleteChoice
                    && !this.dialogCalculationRequiredConfirm
                ) {
                    this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
                    this.deleteConfirmText = '';
                }
            }, 500);
        },
        /**
         * Handles shared post-save logic for simple and builder product flows.
         *
         * @param {Object} response
         * @param {Object} payload
         * @returns {Promise<void>}
         */
        async handleProductSaved(response, payload, options = {}) {
            const { refreshList = true, refreshHistory = true } = options;
            const categoryWarnings = response.data.category_warnings || [];
            if (categoryWarnings.length) {
                showAlertModal(
                    this.$store,
                    categoryWarnings.join(" "),
                    "warning",
                    12000,
                );
            }

            try {
                const cachedRaw = sessionStorage.getItem("PRICE_LIST_PRODUCTS");
                if (cachedRaw) {
                    const existingPriceListProducts = JSON.parse(cachedRaw);
                    if (Array.isArray(existingPriceListProducts?.items)) {
                        const productIndex =
                            existingPriceListProducts.items.findIndex(
                                item =>
                                    item.product_code ===
                                    (payload.old_product_code ||
                                        payload.product_code),
                            );

                        if (productIndex !== -1) {
                            existingPriceListProducts.items[productIndex] =
                                response.data.product;
                        } else {
                            existingPriceListProducts.items.push(
                                cloneDeep(response.data.product),
                            );
                        }
                        sessionStorage.setItem(
                            "PRICE_LIST_PRODUCTS",
                            JSON.stringify(existingPriceListProducts),
                        );
                    }
                }
            } catch (cacheError) {
                console.error(
                    "Failed to update cached price list products:",
                    cacheError,
                );
            }

            if (refreshList) {
                await this.getPriceListProducts("save-product");
            }
            if (refreshHistory) {
                this.refreshPriceListHistory();
            }
        },
        refreshPriceListHistory() {
            const history = this.$refs.priceListHistory;
            if (history && typeof history.reload === "function") {
                history.reload();
            }
        },
        async removeComponentsFromPriceList(
            productCodes = [],
            priceListId = null,
        ) {
            const normalizedCodes = [
                ...new Set(
                    (productCodes || [])
                        .map(code => String(code).trim())
                        .filter(Boolean),
                ),
            ];
            const resolvedPriceListId = priceListId || this.selectedPriceList;
            if (!normalizedCodes.length || !resolvedPriceListId) {
                return;
            }

            for (const productCode of normalizedCodes) {
                try {
                    await apiClient({
                        method: "delete",
                        url: "/api/remove_product_from_price_list/",
                        data: {
                            product_code: productCode,
                            price_list_ids: [resolvedPriceListId],
                        },
                    });
                } catch (error) {
                    console.error(
                        `Failed to remove ${productCode} from price list:`,
                        error,
                    );
                }
            }
        },
        /**
         * Creates a new product or updates an existing one by sending data to the server.
         *
         * @param {Object} product - The product object to create or update.
         * @returns {Promise<Object>} - The server response.
         */
        async createProduct(product, options = {}) {
            const { silent = false } = options;
            try {
                const normalizedProduct = {
                    ...product,
                    price: parseNumericInput(product?.price),
                };
                return await apiClient.post(
                    "/api/create_product/",
                    normalizedProduct,
                );
            } catch (error) {
                if (!silent) {
                    showAlertModal(
                        this.$store,
                        "A apărut o eroare la actualizarea produsului. Vă rugăm reîncărcați pagina.",
                        "danger",
                        12000,
                        error,
                    );
                }
                console.error(
                    "createProduct error:",
                    error?.response?.data || error,
                );
                throw error;
            }
        },
    },
};
</script>

<style scoped>
.products-toolbar :deep(.v-toolbar__content) {
    height: auto !important;
    min-height: 64px;
    overflow: visible;
    padding-block: 8px;
    padding-inline: 16px;
}

.products-toolbar-inner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
    width: 100%;
    min-width: 0;
}

.products-toolbar-title {
    flex: 0 0 auto !important;
    width: auto !important;
    max-width: none !important;
    margin-inline-end: 0 !important;
    padding-inline-end: 4px;
    white-space: nowrap;
}

.products-toolbar-controls {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex: 1 1 320px;
    min-width: 0;
}

.products-toolbar-field {
    flex: 1 1 150px;
    min-width: 140px;
    max-width: 240px;
}

.products-toolbar-field :deep(.v-field),
.products-toolbar-field :deep(.v-select__selection-text) {
    min-width: 0;
}

.products-toolbar-field :deep(.v-select__selection-text) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.products-toolbar-actions {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 4px;
}

.products-toolbar-toggle {
    flex: 0 0 auto;
}

.products-table-collapsed :deep(.v-table__wrapper) {
    display: none;
}

.products-table-collapsed :deep(.v-data-table-footer) {
    display: none;
}

.product-code-cell {
    min-height: 28px;
}

.product-code-cell--child {
    padding-left: 2px;
}

.multi-furnizor-toggle {
    flex: 0 0 auto;
    margin-inline: -4px;
}

.multi-furnizor-child-spacer {
    display: inline-block;
    width: 28px;
    flex: 0 0 28px;
}

.furnizor-cell {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 4px;
    max-width: 100%;
}

.furnizor-cell__label {
    min-width: 0;
}

.furnizor-cell__chip {
    height: 18px !important;
    font-size: 0.65rem !important;
}

.furnizor-cell__star {
    font-weight: 600;
}

.discount-cell--yes {
    cursor: help;
    font-weight: 600;
    color: rgb(var(--v-theme-primary));
}

.discount-tooltip {
    max-width: 320px;
    white-space: pre-wrap;
    word-break: break-word;
}

/* Group frame for expanded multi-furnizor product rows */
.products-table :deep(tr.product-row--furnizor-group-start td),
.products-table :deep(tr.product-row--furnizor-group-middle td),
.products-table :deep(tr.product-row--furnizor-group-end td) {
    background-color: rgba(var(--v-theme-primary), 0.04);
    border-left: none;
    border-right: none;
}

.products-table :deep(tr.product-row--furnizor-group-start td:first-child),
.products-table :deep(tr.product-row--furnizor-group-middle td:first-child),
.products-table :deep(tr.product-row--furnizor-group-end td:first-child) {
    box-shadow: inset 3px 0 0 rgb(var(--v-theme-primary));
    border-left: 1px solid rgba(var(--v-theme-primary), 0.35);
}

.products-table :deep(tr.product-row--furnizor-group-start td:last-child),
.products-table :deep(tr.product-row--furnizor-group-middle td:last-child),
.products-table :deep(tr.product-row--furnizor-group-end td:last-child) {
    border-right: 1px solid rgba(var(--v-theme-primary), 0.35);
}

.products-table :deep(tr.product-row--furnizor-group-start td) {
    border-top: 1px solid rgba(var(--v-theme-primary), 0.35);
}

.products-table :deep(tr.product-row--furnizor-group-start td:first-child) {
    border-top-left-radius: 6px;
}

.products-table :deep(tr.product-row--furnizor-group-start td:last-child) {
    border-top-right-radius: 6px;
}

.products-table :deep(tr.product-row--furnizor-group-end td) {
    border-bottom: 1px solid rgba(var(--v-theme-primary), 0.35);
}

.products-table :deep(tr.product-row--furnizor-group-end td:first-child) {
    border-bottom-left-radius: 6px;
}

.products-table :deep(tr.product-row--furnizor-group-end td:last-child) {
    border-bottom-right-radius: 6px;
}

.products-table :deep(tr.product-row--furnizor-child td) {
    color: rgba(var(--v-theme-on-surface), 0.82);
}

.products-table :deep(tr.product-row--multi-furnizor:not(.product-row--furnizor-group-start) td:first-child) {
    box-shadow: inset 3px 0 0 rgba(var(--v-theme-primary), 0.35);
}

.products-toolbar-spacer {
    flex: 1 1 auto;
    min-width: 0;
}

.products-table :deep(thead th) {
    font-weight: 700;
    white-space: nowrap;
    vertical-align: middle;
    text-align: center !important;
}

.products-table :deep(.v-data-table-header__content) {
    font-weight: 700;
    white-space: nowrap;
    align-items: center;
    justify-content: center !important;
    text-align: center;
    width: 100%;
}

.products-table :deep(thead th.header-wrap) {
    white-space: normal;
    max-width: 5.5rem;
    vertical-align: middle;
}

.products-table :deep(thead th.header-wrap .v-data-table-header__content) {
    white-space: normal;
    line-height: 1.15;
    text-align: center;
    justify-content: center !important;
}

.products-table :deep(.header-title-wrap) {
    display: inline-block;
    max-width: 4.5rem;
    white-space: normal;
    line-height: 1.15;
    font-weight: 700;
    text-align: center;
    vertical-align: middle;
}

.products-table :deep(tbody td) {
    text-align: center !important;
}

.products-table :deep(th.product-name-header),
.products-table :deep(td.product-name-cell) {
    text-align: left !important;
}

.products-table :deep(th.product-name-header .v-data-table-header__content) {
    justify-content: flex-start !important;
    text-align: left;
}

.products-table :deep(.cell-center) {
    display: block;
    width: 100%;
    text-align: center;
}

.products-table :deep(td .v-checkbox),
.products-table :deep(td .v-input) {
    display: flex;
    justify-content: center;
}

.products-table :deep(td .v-selection-control) {
    justify-content: center;
}

.products-table :deep(thead th.header-nowrap),
.products-table :deep(td.actions-cell) {
    white-space: nowrap;
    width: 1%;
}

.products-row-actions {
    display: inline-flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    gap: 8px;
    white-space: nowrap;
}

.active-item {
    background-color: #0d6efd;
    color: white;
}
</style>
<style>
.table-dropdown-menu .v-list-item {
    padding: 5px 10px !important;
    min-height: auto !important;
}

.table-dropdown-menu .v-divider {
    margin: 0px 5px !important;
}
</style>
